/**
 * Star Map Celestial Integration
 * Adapted from shopify-starmap-work myjs.js to work with citymap-shopify UI
 */

(function() {
    'use strict';

    // Custom toast notification (replaces native alert)
    function showToast(message, type) {
        type = type || 'error';
        var existing = document.getElementById('starmap-toast');
        if (existing) existing.remove();

        var toast = document.createElement('div');
        toast.id = 'starmap-toast';
        toast.style.cssText = 'position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:99999;padding:14px 28px;border-radius:8px;font-family:Outfit,Helvetica,Arial,sans-serif;font-size:14px;font-weight:500;line-height:1.4;max-width:420px;width:max-content;text-align:center;box-shadow:0 8px 32px rgba(0,0,0,0.18);opacity:0;transition:opacity 0.3s,transform 0.3s;pointer-events:none;';

        if (type === 'error') {
            toast.style.background = '#16212c';
            toast.style.color = '#fff';
        } else {
            toast.style.background = '#fff';
            toast.style.color = '#16212c';
            toast.style.border = '1px solid #e0e0e0';
        }

        toast.textContent = message;
        document.body.appendChild(toast);

        requestAnimationFrame(function() {
            toast.style.opacity = '1';
            toast.style.transform = 'translateX(-50%) translateY(0)';
        });

        setTimeout(function() {
            toast.style.opacity = '0';
            toast.style.transform = 'translateX(-50%) translateY(-10px)';
            setTimeout(function() { toast.remove(); }, 300);
        }, 3500);
    }

    // Configuration
    const proxy_loc = "https://stackhouse-v2.karangoyal.cc/";
    // Use localhost for development, production URL for live
    const BACKEND_API_URL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
        ? "http://127.0.0.1:8000/api/v1/starmap"
        : "https://tiles.distantlines.de/api/v1/starmap";
    let order_id = generateUUID(); // Use proper UUID
    let currentLat = 52.2689;  // Default to Braunschweig
    let currentLng = 10.5268;
    let celestialInitialized = false;

    /* PROJ-99: Bearbeiten-Modus. Geprueft wird der PARAMETER, nicht window.DLCartEdit — der
       Helfer (assets/cart-edit.js) schaltet sich bei einer verschwundenen Zeile asynchron
       wieder ab, diese Datei liest hier aber schon beim Laden. Ein `?edit=` heisst in JEDEM
       Fall: der Kunde kommt aus dem Warenkorb, also duerfen die Kampagnen-Presets der Section
       (`preset_params`, in 16 von 19 Sternkarten-Templates gesetzt) NICHT greifen — sie wuerden
       Datum, Ort, Form, Farbe, Stil, Titel, Rand und die Anzeigezeilen ueberschreiben.
       Quelle wie ueberall im Editor: DLEditorSearch (PROJ-44), sonst die Adresszeile. */
    const istBearbeitenModus = new URLSearchParams(window.DLEditorSearch || window.location.search).get('edit') !== null;

    /* initImageUpload() laeuft erst 600 ms nach DOMContentLoaded (siehe unten). Vorher haengt am
       Foto-Schalter kein Handler — der Bearbeiten-Modus wartet deshalb auf diese Marke. */
    let bildUploadBereit = false;

    // Generate UUID for job tracking (same as citymap)
    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Image upload state
    let starmapCropper = null;
    let uploadedImageUrl = null;
    let uploadedImageData = null;

    // Unified Color System state
    let currentPreset = 'inner-filled';  // Track which preset is active
    let currentBaseColor = '#000000';  // Track the base color (from Frame Color picker)

    // Module-level function to reapply current preset (callable from anywhere)
    function reapplyCurrentPreset() {
        applyPresetColorsGlobal(currentPreset, currentBaseColor);
    }

    // Global preset application function (module level)
    // Updated per client specs: NO auto-contrast - strictly follow preset color rules
    function applyPresetColorsGlobal(preset, baseColor) {
        currentPreset = preset;
        currentBaseColor = baseColor;

        // Set data attribute for CSS visibility control
        const starmapCustomizer = document.querySelector('.starmap-customizer');
        if (starmapCustomizer) {
            starmapCustomizer.setAttribute('data-preset', preset);
        }

        let frameColor, starMapColor, starsColor, outlineColor, textColor;

        // Determine colors based on preset (per client specifications)
        // NO auto-contrast - always use explicit white/base as specified
        switch(preset) {
            case 'filled':
                // Preset 1 - Full Color: base everywhere, white accents
                frameColor = baseColor;
                starMapColor = baseColor;
                starsColor = '#ffffff';
                outlineColor = '#ffffff';
                textColor = '#ffffff';
                break;
            case 'outline':
                // Preset 2 - White Card: white everywhere, base accents
                frameColor = '#ffffff';
                starMapColor = '#ffffff';
                starsColor = baseColor;
                outlineColor = baseColor;
                textColor = baseColor;
                break;
            case 'inner-filled':
                // Preset 3 - White Card, Colored Sky: white frame, base sky, base accents
                frameColor = '#ffffff';
                starMapColor = baseColor;
                starsColor = '#ffffff';
                outlineColor = baseColor;
                textColor = baseColor;
                break;
            case 'ring':
                // Preset 4 - Colored Card, White Sky: base frame, white sky, white accents
                frameColor = baseColor;
                starMapColor = '#ffffff';
                starsColor = baseColor;
                outlineColor = '#ffffff';
                textColor = '#ffffff';
                break;
        }

        // Apply colors using existing functions
        if (typeof changeFrameColor === 'function') {
            changeFrameColor(frameColor, textColor);
        }
        if (typeof changeStarMapColor === 'function') {
            changeStarMapColor(starMapColor, starsColor);
        }

        // Apply outline color to all shapes
        applyOutlineColorGlobal(outlineColor);

        console.log('Preset applied:', { preset, baseColor, frameColor, starMapColor, starsColor, outlineColor, textColor });
    }

    // Global outline color application (module level)
    function applyOutlineColorGlobal(color) {
        // Get current shape
        const celestialMap = document.getElementById('celestial-map');
        const isCircle = celestialMap && celestialMap.classList.contains('shape-circle');
        const isHeart = celestialMap && celestialMap.classList.contains('shape-heart');
        const isCompass = celestialMap && celestialMap.classList.contains('shape-compass');

        // For circle and heart: fill only, no stroke
        // For compass: both fill and stroke
        const borSelectors = [
            '#celestial-map.shape-circle .custom_iframe .bor',
            '#celestial-map.shape-heart .custom_iframe .bor',
            '#celestial-map.shape-compass .custom_iframe .bor',
            '.custom_iframe .bor',
            '.bor'
        ];

        borSelectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(el => {
                el.style.setProperty('fill', color, 'important');
                // Circle and heart: stroke none, Compass: stroke with color
                if (isCircle || isHeart) {
                    el.style.setProperty('stroke', color, 'important');
                } else {
                    el.style.setProperty('stroke', color, 'important');
                    document.querySelector('.compass-border').style.setProperty('stroke', color, 'important');
                }
            });
        });

        // strokeCouple elements - same logic
        document.querySelectorAll('.strokeCouple').forEach(el => {
            if (isCircle || isHeart) {
                el.style.setProperty('stroke', color, 'important');
            } else {
                el.style.setProperty('stroke', color, 'important');
                document.querySelector('.compass-border').style.setProperty('stroke', color, 'important');
            }
        });
    }

    // Clear inline text color styles (used when background is disabled)
    function clearTextColorStyles() {
        // Clear custom-frame text color
        const customFrame = document.querySelector('.custom-frame.bg-new');
        if (customFrame) {
            customFrame.style.removeProperty('color');
        }

        // Clear preview title and subtitle
        const previewTitle = document.getElementById('preview-title');
        const previewSubtitle = document.getElementById('preview-subtitle');
        if (previewTitle) {
            previewTitle.style.removeProperty('color');
        }
        if (previewSubtitle) {
            previewSubtitle.style.removeProperty('color');
        }

        // Clear custom-textarea text
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.style.removeProperty('color');
            customTextarea.querySelectorAll('*').forEach(el => {
                el.style.removeProperty('color');
            });
        }

        // Clear custom-address text
        const customAddress = document.querySelector('.custom-address');
        if (customAddress) {
            customAddress.style.removeProperty('color');
            customAddress.querySelectorAll('*').forEach(el => {
                el.style.removeProperty('color');
            });
        }
    }

    // Apply text color (used when background image is enabled)
    // This applies to all text elements and SVG strokes
    function applyTextColor(color) {
        const customFrame = document.querySelector('.custom-frame.bg-new');

        // Update frame text color
        if (customFrame) {
            customFrame.style.color = color;
        }

        // Update preview title and subtitle
        const previewTitle = document.getElementById('preview-title');
        const previewSubtitle = document.getElementById('preview-subtitle');
        if (previewTitle) {
            previewTitle.style.setProperty('color', color, 'important');
        }
        if (previewSubtitle) {
            previewSubtitle.style.setProperty('color', color, 'important');
        }

        // Update custom-textarea text
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.style.setProperty('color', color, 'important');
            customTextarea.querySelectorAll('*').forEach(el => {
                el.style.setProperty('color', color, 'important');
            });
        }

        // Update custom-address text - same color as custom-textarea
        const customAddress = document.querySelector('.custom-address');
        if (customAddress) {
            customAddress.style.setProperty('color', color, 'important');
            customAddress.querySelectorAll('*').forEach(el => {
                el.style.setProperty('color', color, 'important');
            });
        }

        // Update border/stroke colors - follows text color
        applyOutlineColorGlobal(color);

        // Update compass elements specifically
        const compassBorder = document.querySelector('.compass-border');
        if (compassBorder) {
            compassBorder.setAttribute('stroke', color);
            compassBorder.style.setProperty('stroke', color, 'important');
        }

        console.log('Applied text color:', color);
    }

    // Debounced celestial update function (800ms delay to prevent rapid firing)
    const debouncedUpdateCelestialDateTime = debounce(function() {
        updateCelestialDateTime();
    }, 800);

    // Debounce utility function
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // Style color presets
    const stylePresets = {
        'midnight-blue': { background: '#0a1628', stars: '#ffffff', lines: '#4a90d9', text: '#ffffff' },
        'deep-space': { background: '#000000', stars: '#ffffff', lines: '#666666', text: '#ffffff' },
        'starlight-white': { background: '#ffffff', stars: '#000000', lines: '#333333', text: '#000000' },
        'cosmic-purple': { background: '#1a1a2e', stars: '#ffffff', lines: '#9b59b6', text: '#ffffff' },
        'aurora-green': { background: '#1f4037', stars: '#ffffff', lines: '#2ecc71', text: '#ffffff' },
        'sunset-gold': { background: '#2d132c', stars: '#ffd700', lines: '#ff6b6b', text: '#ffd700' },
        'rose-nebula': { background: '#2d132c', stars: '#ffb6c1', lines: '#ff69b4', text: '#ffffff' },
        'ocean-sky': { background: '#16213e', stars: '#87ceeb', lines: '#00bcd4', text: '#ffffff' }
    };

    // Wait for DOM and dependencies to be ready
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize immediately
        initStarmapCelestial();
    });

    function initStarmapCelestial() {
        if (typeof Celestial === 'undefined') {
            console.warn('Celestial.js not loaded yet, retrying...');
            setTimeout(initStarmapCelestial, 100);
            return;
        }

        console.log('Initializing Starmap Celestial integration');

        // Initialize Celestial.js
        initCelestial();

        // Initialize Google Places autocomplete
        if (typeof google !== 'undefined' && google.maps && google.maps.places) {
            initLocationAutocomplete();
        } else {
            // Wait for Google Maps API to load (500ms polling to reduce CPU during starmap load)
            var googleMapsCheck = setInterval(function() {
                if (typeof google !== 'undefined' && google.maps && google.maps.places) {
                    clearInterval(googleMapsCheck);
                    initLocationAutocomplete();
                }
            }, 500);
            // Stop checking after 5 seconds
            setTimeout(function() { clearInterval(googleMapsCheck); }, 5000);
        }

        // Bind form inputs to Celestial
        bindFormInputs();

        // Initialize timepicker if jQuery is available
        if (typeof $ !== 'undefined' && $.fn.timepicker) {
            initTimePicker();
        }

        // Set default date to today
        //setDefaultDate();

        // Standardschrift (markierte Kachel) in Feld und Vorschau — vor der Groessenanpassung
        standardSchriftSetzen();

        // Adjust font size based on initial content
        adjustTextareaFontSize();

        // Initialize frame picker
        initFramePicker();

        // Initialize Weiter-Buttons (Tab 1-3 navigation; Cart-Button liegt in Tab 4)
        initWeiterNav();

        // Initial sync: set defaults from JS (Liquid | default: won't override saved Shopify settings)
        // PROJ-44: DLEditorSearch = Presets bzw. Original-Query vor dem Geo-Cleanup (Meta blockte lat/lng)
        var urlParams = new URLSearchParams(window.DLEditorSearch || window.location.search);
        if (!urlParams.get('lat') && !urlParams.get('city')) {
            syncLocationToPreview('Braunschweig, Deutschland', currentLat, currentLng);
        }

        celestialInitialized = true;

        // Apply URL preset after initialization
        /* PROJ-99: Im Bearbeiten-Modus ausgelassen — der gespeicherte Zustand aus der
           Warenkorbzeile hat Vorrang vor den Kampagnen-Presets der Landeseite. Es gibt genau
           EINE Aufrufstelle von applyPresetFromURL(), sonst waere der Guard umgehbar. */
        if (!istBearbeitenModus) {
            setTimeout(function() { applyPresetFromURL(urlParams); }, 800);
        }

        /* PROJ-99: Bearbeiten-Modus starten (tut nichts ohne ?edit=). */
        bearbeitenModusStarten();
    }

    // Apply preset configuration from URL parameters (for product links)
    function applyPresetFromURL(urlParams) {
        var preset = {
            date: urlParams.get('date'),
            time: urlParams.get('time'),
            lat: urlParams.get('lat'),
            lng: urlParams.get('lng'),
            layout: urlParams.get('layout'),
            color: urlParams.get('color'),
            mapStyle: urlParams.get('mapStyle'),
            title: urlParams.get('title'),
            location: urlParams.get('location'),
            grid: urlParams.get('grid'),
            constellations: urlParams.get('constellations'),
            border: urlParams.get('border')
        };

        // Nothing to do if no preset parameters
        if (!preset.date && !preset.lat && !preset.layout && !preset.color) return;

        // 1. Set date and time
        if (preset.date) {
            var dateInput = document.getElementById('starmap-date-input');
            if (dateInput) {
                dateInput.value = preset.date;
            }
        }
        if (preset.time) {
            var timeInput = document.getElementById('starmap-time-input');
            if (timeInput) {
                timeInput.value = preset.time;
            }
        }

        // 2. Set location coordinates
        if (preset.lat && preset.lng) {
            currentLat = parseFloat(preset.lat);
            currentLng = parseFloat(preset.lng);
            updateCelestialLocation(currentLat, currentLng);
        }

        // Update Celestial with date/time/location
        if (preset.date || preset.lat) {
            updateCelestialDateTime();
        }

        // 3. Set layout/shape (circle, heart, compass)
        if (preset.layout) {
            var shapeLinks = document.querySelectorAll('.starmap-customizer .elem__picker ul li a[data-layout]');
            shapeLinks.forEach(function(link) {
                link.classList.remove('current');
                if (link.getAttribute('data-layout') === preset.layout) {
                    link.classList.add('current');
                }
            });
            changeShape(preset.layout);
        }

        // 4. Set map style preset (filled, inner-filled, outline, ring)
        if (preset.mapStyle) {
            var mapStyleOptions = document.querySelectorAll('.map-style-option');
            mapStyleOptions.forEach(function(option) {
                option.classList.remove('current');
                if (option.getAttribute('data-style') === preset.mapStyle) {
                    option.classList.add('current');
                }
            });
        }

        // 5. Set base color and apply with preset
        if (preset.color) {
            var baseColor = '#' + preset.color;
            currentBaseColor = baseColor;

            // Update frame color picker UI
            var frameColorLinks = document.querySelectorAll('.frame-color-picker .wrap a');
            var colorMatched = false;
            frameColorLinks.forEach(function(link) {
                link.classList.remove('current');
                if (link.getAttribute('data-color') === baseColor) {
                    link.classList.add('current');
                    colorMatched = true;
                }
            });
            if (!colorMatched) {
                // Set custom color picker
                var customColorInput = document.getElementById('custom-color-frame');
                if (customColorInput) {
                    customColorInput.value = baseColor;
                }
            }
        }

        // Apply color preset together
        var activePreset = preset.mapStyle || currentPreset;
        var activeColor = preset.color ? '#' + preset.color : currentBaseColor;
        applyPresetColorsGlobal(activePreset, activeColor);

        // 6. Set checkboxes (grid, constellations)
        if (preset.grid === 'true') {
            var gridCheckbox = document.getElementById('show-grid');
            if (gridCheckbox && !gridCheckbox.checked) {
                gridCheckbox.checked = true;
                updateGrid(true);
            }
        }
        if (preset.constellations === 'true') {
            var constellationsCheckbox = document.getElementById('show-constellations');
            if (constellationsCheckbox && !constellationsCheckbox.checked) {
                constellationsCheckbox.checked = true;
                updateConstellations(true);
            }
        }

        // 7. Set border (without / with)
        if (preset.border === 'with') {
            var borderLink = document.querySelector('.border__picker .border-options a[data-border="with"]');
            if (borderLink) borderLink.click();
        }

        // 8. Set title/message and location text
        if (preset.title) {
            var textMessage = document.getElementById('textMessage');
            if (textMessage) {
                textMessage.value = preset.title;
            }
        }
        if (preset.location) {
            var textLocation = document.getElementById('textLocation');
            var locationInput = document.getElementById('starmap-location-input');
            if (textLocation) textLocation.value = preset.location;
            if (locationInput) locationInput.value = preset.location;
        }

        // Sync coordinates to preview
        if (preset.lat && preset.lng) {
            syncLocationToPreview(
                preset.location || '',
                parseFloat(preset.lat),
                parseFloat(preset.lng)
            );
        }

        // Sync date to preview
        if (preset.date) {
            syncDateToPreview(preset.date);
        }

        // 9. Override display fields (overwrite auto-generated text)
        var displayDate = urlParams.get('displayDate');
        var displayLocation = urlParams.get('displayLocation');
        var displayCoords = urlParams.get('displayCoords');

        // FOUC-Fix: setTimeout(500) → sofort. URL-Display-Params sind Page-Daten, kein async-Lookup nötig.
        if (displayDate !== null) {
            var textDate = document.getElementById('textDate');
            if (textDate) textDate.value = displayDate;
        }
        if (displayLocation !== null) {
            var textLoc = document.getElementById('textLocation');
            if (textLoc) textLoc.value = displayLocation;
        }
        if (displayCoords !== null) {
            var textCoords = document.getElementById('textCoordinates');
            if (textCoords) textCoords.value = displayCoords;
        }
        if (displayDate !== null || displayLocation !== null || displayCoords !== null) {
            updatePreviewFromInputs();
        }

        // 10. Enable photo toggle if requested
        var photoParam = urlParams.get('photo');
        if (photoParam === 'true' || photoParam === '1') {
            var enableToggle = document.getElementById('enable-custom-image');
            if (enableToggle && !enableToggle.checked) {
                enableToggle.checked = true;
                enableToggle.dispatchEvent(new Event('change'));
            }
        }

        // Final preview update
        updatePreviewFromInputs();
    }

    // Current orientation for frame display
    let currentOrientation = 'portrait';

    // Frame image URLs
    const frameImages = {
        portrait: {
            brown: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/brown_fr2.png?v=1774861845',
            white: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/white_fr.png',
            black: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/black_fr.png'
        },
        landscape: {
            brown: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/brown_landscape2.png?v=1774861844',
            white: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/white_landscape.png?v=1763296140',
            black: 'https://cdn.shopify.com/s/files/1/0977/3672/0709/files/black_landscape_1.png?v=1763296139'
        }
    };

    // Initialize frame picker functionality
    // -------------------------------------------------------------------
    // Weiter-Button (am Ende von Tab 1-3) — wechselt zum naechsten Tab.
    // Cart-Button + Preis liegen jetzt INSIDE Tab 4 (Format) am Ende.
    // -------------------------------------------------------------------
    function initWeiterNav() {
        const buttons = document.querySelectorAll('.starmap-customizer .weiter-btn[data-target-tab]');
        buttons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                const targetTab = btn.dataset.targetTab;
                const scope = btn.closest('.starmap-customizer');
                if (!scope) return;
                const link = scope.querySelector('.main__switcher > ul > li > a[data-tab="' + targetTab + '"]');
                if (link) link.click();
                if (window.matchMedia('(max-width: 991px)').matches) {
                    const sw = scope.querySelector('.main__switcher');
                    if (sw) sw.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        });
    }

    function initFramePicker() {
        const frameLinks = document.querySelectorAll('.starmap-customizer .image__changer.frame-picker ul li a');

        frameLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();

                // Remove current from all frame links
                frameLinks.forEach(function(l) {
                    l.classList.remove('current');
                });

                // Add current to clicked link
                this.classList.add('current');

                // Update frame image
                updateFrameImage();
            });
        });
    }

    // Update frame image based on selected frame and orientation
    function updateFrameImage() {
        // Check if current product type should show frames
        const currentTypeTab = document.querySelector('.starmap-customizer .tab__switcher ul li a.current');
        const currentTypeId = currentTypeTab ? currentTypeTab.getAttribute('data-id') : '1';
        const typeConfig = window.productTypeConfig ? window.productTypeConfig['type' + currentTypeId] : null;

        // CSS-Holzrahmen-Pattern (analog Citymap, project_fotoposter_v1.md
        // Z. 8.26): .has-frame + data-frame-color auf .inn.single-map-view
        // umschliesst das ganze Poster. Altes PNG-<img> wird versteckt.
        const frameOverlayImg = document.getElementById('frame-overlay-img');
        const mediaContainer = document.querySelector('.starmap-customizer .canvas__wrapper .media');
        const posterEl = document.querySelector('.starmap-customizer .canvas__wrapper .inn.single-map-view');

        // If product type doesn't have frame picker enabled, hide frame and return
        if (!typeConfig || !typeConfig.showFramePicker) {
            if (frameOverlayImg) {
                frameOverlayImg.style.display = 'none';
                frameOverlayImg.src = '';
            }
            if (posterEl) {
                posterEl.classList.remove('has-frame');
                posterEl.removeAttribute('data-frame-color');
            }
            return;
        }

        // Get selected frame
        const currentFrame = document.querySelector('.starmap-customizer .image__changer.frame-picker ul li a.current');
        if (!currentFrame) {
            if (posterEl) {
                posterEl.classList.remove('has-frame');
                posterEl.removeAttribute('data-frame-color');
            }
            return;
        }

        const frameColor = currentFrame.getAttribute('data-frame-color');
        if (!frameColor) {
            if (posterEl) {
                posterEl.classList.remove('has-frame');
                posterEl.removeAttribute('data-frame-color');
            }
            return;
        }

        // CSS-Holzrahmen ums ganze Poster aktivieren.
        if (posterEl) {
            posterEl.classList.add('has-frame');
            posterEl.setAttribute('data-frame-color', frameColor);
        }

        // Altes PNG-<img> verstecken (durch CSS-Frame ersetzt).
        if (frameOverlayImg) {
            frameOverlayImg.style.display = 'none';
            frameOverlayImg.src = '';
        }

        // Update media container data-resize-type
        if (mediaContainer) {
            mediaContainer.setAttribute('data-resize-type', currentOrientation);
        }

        // Update hidden field for frame
        const frameHidden = document.getElementById('starmap-frame');
        if (frameHidden) frameHidden.value = frameColor;
    }

    // Function to update orientation (called from starmap.js when orientation changes)
    window.updateStarmapOrientation = function(orientation) {
        currentOrientation = orientation;
        updateFrameImage();

        // Update hidden field for orientation
        const orientationHidden = document.getElementById('starmap-orientation');
        if (orientationHidden) orientationHidden.value = orientation;
    };

    // Expose updateFrameImage globally for external calls
    window.updateStarmapFrameImage = updateFrameImage;

    function initCelestial() {
        const container = document.getElementById('celestial-map');
        console.log('=== CELESTIAL INIT ===');
        console.log('Container:', container ? container.offsetWidth + 'x' + container.offsetHeight : 'NOT FOUND');
        console.log('Window:', window.innerWidth + 'x' + window.innerHeight);
        console.log('Device Pixel Ratio:', window.devicePixelRatio);
        console.log('Config width: 1000, Effective canvas:', 1000 * (window.devicePixelRatio || 1) + 'px');

        const config = {
            width: 1000,
            projection: "airy",
            transform: "equatorial",
            center: null,
            geopos: null,
            follow: "zenith",
            orientationfixed: true,
            zoomlevel: null,
            zoomextend: 10,
            adaptable: true,
            interactive: false,
            disableAnimations: true,  // Disable rotation/projection animations on load (prevents 100+ redraws)
            location: false,
            formFields: {
                location: true,
                general: true,
                stars: true,
                dsos: true,
                constellations: true,
                lines: true,
                other: true,
                download: true
            },
            advanced: true,
            daterange: [],
            settimezone: true,
            controls: false,
            lang: "de",
            culture: "",
            container: "celestial-map",
            stars: {
                show: true,
                limit: 6,
                colors: false,
                style: { fill: "#ffffff", opacity: 1 },
                designation: false,
                designationType: "desig",
                designationStyle: {
                    fill: "#ffffff",
                    font: "11px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    align: "left",
                    baseline: "top"
                },
                designationLimit: 2.5,
                propername: false,
                propernameType: "de",
                propernameStyle: {
                    fill: "#ffffff",
                    font: "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    align: "right",
                    baseline: "bottom"
                },
                propernameLimit: -100,
                size: 12,
                exponent: -0.29,
                data: "stars.6.json"
            },
            dsos: { show: false },
            constellations: {
                show: true,
                names: false,  // Disabled to reduce crowding
                namesType: "de",
                nameLimit: -100,  // Very low limit to show no names
                nameStyle: {
                    fill: "transparent",
                    align: "center",
                    baseline: "middle",
                    opacity: 0,
                    font: ["0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif"]
                },
                lineStyle: { stroke: "#cccccc", width: 1, opacity: 0.75 },
                lines: true,
                bounds: false,
                boundStyle: { stroke: "#ccff00", width: 2, opacity: 0.8, dash: [2, 6] }
            },
            mw: {
                show: false,
                style: { fill: "#ffffff", opacity: "0.15" }
            },
            lines: {
                graticule: {
                    show: false,
                    stroke: "#949494",
                    width: 2.8,
                    opacity: 0.7,
                    lon: { pos: [], fill: "#eee", font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif" },
                    lat: { pos: [], fill: "#eee", font: "10px 'Lucida Sans Unicode', Helvetica, Arial, sans-serif" }
                },
                equatorial: { show: false },
                ecliptic: { show: false },
                galactic: { show: false },
                supergalactic: { show: false }
            },
            horizon: { show: false },
            daylight: { show: false },
            planets: {
                show: false,
                which: [],
                symbols: {
                    lun: { symbol: "\u25CF", letter: "L", fill: "#ffffff", size: 40 }
                },
                symbolStyle: {
                    fill: "#cccccc",
                    opacity: 1,
                    font: "bold 17px 'DejaVu Sans Mono', 'Arial Unicode MS', sans-serif",
                    align: "center",
                    baseline: "middle"
                },
                symbolType: "symbol",
                names: false
            },
            form: false,
            datapath: "https://tiles.distantlines.de/starmap-data/",
            timezoneid: "OZJZSV28I4V8",
            background: { fill: "#000000", opacity: 1, stroke: "transparent", width: 0 }
        };

        Celestial.display(config);
        // Animations stay disabled for better mobile performance
    }

    function initLocationAutocomplete() {
        const input = document.getElementById('starmap-location-input');
        if (!input) return;

        const autocomplete = new google.maps.places.Autocomplete(input);

        google.maps.event.addListener(autocomplete, 'place_changed', function() {
            const place = autocomplete.getPlace();
            if (place.geometry && place.geometry.location) {
                currentLat = place.geometry.location.lat();
                currentLng = place.geometry.location.lng();
                updateCelestialLocation(currentLat, currentLng);

                // Update hidden form fields
                updateLocationFields(input.value, currentLat, currentLng);

                // Sync with text preview inputs
                syncLocationToPreview(input.value, currentLat, currentLng);
            }
        });
    }

    // Sync location/date/time changes to preview text
    function syncLocationToPreview(locationName, lat, lng) {
        // Update textLocation input
        const textLocation = document.getElementById('textLocation');
        if (textLocation) {
            textLocation.value = locationName;
        }

        // Update textCoordinates input
        const textCoordinates = document.getElementById('textCoordinates');
        if (textCoordinates && lat && lng) {
            const latDir = lat >= 0 ? 'N' : 'S';
            const lngDir = lng >= 0 ? 'O' : 'W';
            const absLat = Math.abs(lat);
            const absLng = Math.abs(lng);
            const latDeg = Math.floor(absLat);
            const latMin = Math.round((absLat - latDeg) * 60);
            const lngDeg = Math.floor(absLng);
            const lngMin = Math.round((absLng - lngDeg) * 60);
            textCoordinates.value = `${latDeg}°${String(latMin).padStart(2,'0')}'${latDir} / ${lngDeg}°${String(lngMin).padStart(2,'0')}'${lngDir}`;
        }

        // Update preview
        updatePreviewFromInputs();
    }

    function syncDateToPreview(dateValue) {
        // Format date as readable text with time
        const textDate = document.getElementById('textDate');
        const timeInput = document.getElementById('starmap-time-input');

        if (textDate && dateValue) {
            const date = new Date(dateValue + 'T00:00:00');
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            let formattedDate = date.toLocaleDateString('de-DE', options);

            // Add time if available (24-hour format for German)
            if (timeInput && timeInput.value) {
                formattedDate += ` - ${timeInput.value} Uhr`;
            }

            textDate.value = formattedDate;
        }

        // Update preview
        updatePreviewFromInputs();
    }

    function initTimePicker() {
        const timeInput = document.getElementById('starmap-time-input');
        if (timeInput) {
            timeInput.addEventListener('change', debouncedUpdateCelestialDateTime);
        }
    }

    function setDefaultDate() {
        const dateInput = document.getElementById('starmap-date-input');
        const timeInput = document.getElementById('starmap-time-input');
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const hours = String(today.getHours()).padStart(2, '0');
        const minutes = String(today.getMinutes()).padStart(2, '0');
        const todayStr = `${year}-${month}-${day}`;
        const nowTime = `${hours}:${minutes}`;

        // Set today's date and trigger change event
        if (dateInput) {
            dateInput.value = todayStr;
            dateInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Set current time and trigger change event
        if (timeInput) {
            timeInput.value = nowTime;
            timeInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    function bindFormInputs() {
        // Date input - use debounced update to prevent rapid firing
        const dateInput = document.getElementById('starmap-date-input');
        if (dateInput) {
            dateInput.addEventListener('change', function() {
                debouncedUpdateCelestialDateTime();
                syncDateToPreview(this.value);
            });
            // Also debounce input events for when user types quickly
            dateInput.addEventListener('input', function() {
                debouncedUpdateCelestialDateTime();
                syncDateToPreview(this.value);
            });
        }

        // Time input - use debounced update to prevent rapid firing
        const timeInput = document.getElementById('starmap-time-input');
        if (timeInput) {
            timeInput.addEventListener('change', function() {
                debouncedUpdateCelestialDateTime();
                // Re-sync date with updated time
                const dateInput = document.getElementById('starmap-date-input');
                if (dateInput && dateInput.value) {
                    syncDateToPreview(dateInput.value);
                }
            });
            // Also debounce input events for when user types quickly
            timeInput.addEventListener('input', function() {
                debouncedUpdateCelestialDateTime();
                const dateInput = document.getElementById('starmap-date-input');
                if (dateInput && dateInput.value) {
                    syncDateToPreview(dateInput.value);
                }
            });
        }

        // Constellation checkboxes
        const constellationsCheckbox = document.getElementById('show-constellations');
        if (constellationsCheckbox) {
            constellationsCheckbox.addEventListener('change', function() {
                updateConstellations(this.checked);
            });
        }

        const constellationNamesCheckbox = document.getElementById('show-constellation-names');
        if (constellationNamesCheckbox) {
            constellationNamesCheckbox.addEventListener('change', function() {
                updateConstellationNames(this.checked);
            });
        }

        const starNamesCheckbox = document.getElementById('show-star-names');
        if (starNamesCheckbox) {
            starNamesCheckbox.addEventListener('change', function() {
                updateStarNames(this.checked);
            });
        }

        const gridCheckbox = document.getElementById('show-grid');
        if (gridCheckbox) {
            gridCheckbox.addEventListener('change', function() {
                updateGrid(this.checked);
            });
        }

        const milkyWayCheckbox = document.getElementById('show-milky-way');
        if (milkyWayCheckbox) {
            milkyWayCheckbox.addEventListener('change', function() {
                updateMilkyWay(this.checked);
            });
        }

        // Text & Labels inputs
        initTextLabelInputs();

        // Background toggle
        const bgToggle = document.getElementById('enable-background-style');
        const bgStyleGrid = document.getElementById('background-style-grid');
        const starmapCustomizer = document.querySelector('.starmap-customizer');
        if (bgToggle && bgStyleGrid) {
            bgToggle.addEventListener('change', function() {
                if (this.checked) {
                    bgStyleGrid.style.setProperty('display', 'grid', 'important');
                    // Set data attribute to show text color picker, hide base color picker
                    if (starmapCustomizer) {
                        starmapCustomizer.setAttribute('data-has-background', 'true');
                    }
                    // Disable frame color and border when background is enabled
                    disableFrameAndBorderControls();
                    // Apply white text color by default when background is enabled
                    applyTextColor('#ffffff');
                } else {
                    bgStyleGrid.style.setProperty('display', 'none', 'important');
                    // Remove data attribute to show base color picker, hide text color picker
                    if (starmapCustomizer) {
                        starmapCustomizer.removeAttribute('data-has-background');
                    }
                    // Remove background when toggle is off
                    removeBackground();
                    // Remove current selection
                    const styleLinks = document.querySelectorAll('.starmap-customizer .style-grid li a');
                    styleLinks.forEach(l => l.classList.remove('current'));
                    // Re-enable frame color and border when background is disabled
                    enableFrameAndBorderControls();
                    // Clear inline text color styles set by applyTextColor
                    clearTextColorStyles();
                    // Reapply preset colors when background is removed
                    reapplyCurrentPreset();
                }
            });
        }

        // Text color picker (shown when background image is enabled)
        const textColorLinks = document.querySelectorAll('.text-color-picker .wrap a');
        textColorLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                textColorLinks.forEach(l => l.classList.remove('current'));
                this.classList.add('current');
                const color = this.getAttribute('data-color');
                if (color) {
                    applyTextColor(color);
                }
            });
        });

        // Style picker - apply background images
        const styleLinks = document.querySelectorAll('.starmap-customizer .style-grid li a');
        styleLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                const style = this.getAttribute('data-style');
                const bgUrl = this.getAttribute('data-bg');

                // Remove current from all
                styleLinks.forEach(l => l.classList.remove('current'));
                this.classList.add('current');

                if (style === 'custom') {
                    // Open image upload for custom background
                    triggerBackgroundUpload();
                } else if (bgUrl) {
                    // Apply background image from data-bg attribute
                    applyBackgroundImage(bgUrl);
                }

                // Ensure design__info stays visible
                const designInfo = document.querySelector('.starmap-customizer .design__info');
                if (designInfo) {
                    designInfo.style.display = 'block';
                }
            });
        });

        // Shape picker (Circle, Heart, Compass)
        const shapeLinks = document.querySelectorAll('.starmap-customizer .elem__picker ul li a[data-layout]');
        shapeLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                // Remove current class from all shape links
                shapeLinks.forEach(l => l.classList.remove('current'));
                // Add current class to clicked link
                this.classList.add('current');
                // Change the shape
                const shape = this.getAttribute('data-layout');
                changeShape(shape);
            });
        });

        // Initialize default shape (circle)
        changeShape('circle');

        // Star Map Color Picker
        const starMapColorLinks = document.querySelectorAll('.star-map-color-picker .wrap a');
        starMapColorLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                // Don't prevent default for custom color picker links - let the color picker work
                if (this.classList.contains('custom')) {
                    return;
                }

                e.preventDefault();

                // Remove current from all
                starMapColorLinks.forEach(l => l.classList.remove('current'));
                this.classList.add('current');

                const color = this.getAttribute('data-color');
                if (color) {
                    changeStarMapColor(color);
                }
            });
        });

        // Star Map Custom Color Picker - handle input change with debounce
        const starMapCustomColor = document.getElementById('custom-color-starmap');
        if (starMapCustomColor) {
            const debouncedStarMapColorChange = debounce(function(color) {
                changeStarMapColor(color);
            }, 150);

            starMapCustomColor.addEventListener('input', function() {
                const customLink = this.closest('a');
                if (customLink) {
                    starMapColorLinks.forEach(l => l.classList.remove('current'));
                    customLink.classList.add('current');
                }
                debouncedStarMapColorChange(this.value);
            });
        }

        // Base Color Picker (formerly Frame Color) - drives the unified color system
        const frameColorLinks = document.querySelectorAll('.frame-color-picker .wrap a');
        frameColorLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
                // Don't prevent default for custom color picker links - let the color picker work
                if (this.classList.contains('custom')) {
                    return;
                }

                e.preventDefault();

                // Remove current from all
                frameColorLinks.forEach(l => l.classList.remove('current'));
                this.classList.add('current');

                const color = this.getAttribute('data-color');
                if (color) {
                    // Use unified color system - re-apply current preset with new base color
                    applyPresetWithBaseColor(currentPreset, color);
                }
            });
        });

        // Base Color Custom Color Picker - handle input change with debounce
        const frameCustomColor = document.getElementById('custom-color-frame');
        if (frameCustomColor) {
            const debouncedBaseColorChange = debounce(function(color) {
                // Use unified color system - re-apply current preset with new base color
                applyPresetWithBaseColor(currentPreset, color);
            }, 150);

            frameCustomColor.addEventListener('input', function() {
                const customLink = this.closest('a');
                if (customLink) {
                    frameColorLinks.forEach(l => l.classList.remove('current'));
                    customLink.classList.add('current');
                }
                debouncedBaseColorChange(this.value);
            });
        }

        // Map Style Picker
        const mapStyleOptions = document.querySelectorAll('.map-style-option');
        mapStyleOptions.forEach(function(option) {
            option.addEventListener('click', function(e) {
                e.preventDefault();

                // Remove current from all
                mapStyleOptions.forEach(o => o.classList.remove('current'));
                this.classList.add('current');

                const style = this.getAttribute('data-style');
                applyMapStyle(style);
            });
        });

        // Unified Color System: Apply preset with base color
        // Updated per client specs: NO auto-contrast - strictly follow preset color rules
        function applyPresetWithBaseColor(preset, baseColor) {
            currentPreset = preset;
            currentBaseColor = baseColor;

            // Set data attribute for CSS visibility control (hides Base Color picker for 'outline' preset)
            const starmapCustomizer = document.querySelector('.starmap-customizer');
            if (starmapCustomizer) {
                starmapCustomizer.setAttribute('data-preset', preset);
            }

            let frameColor, starMapColor, starsColor, outlineColor, textColor;

            // Determine colors based on preset (per client specifications)
            // NO auto-contrast - always use explicit white/base as specified
            switch(preset) {
                case 'filled':
                    // Preset 1 - Full Color: base everywhere, white accents
                    frameColor = baseColor;
                    starMapColor = baseColor;
                    starsColor = '#ffffff';
                    outlineColor = '#ffffff';
                    textColor = '#ffffff';
                    break;
                case 'outline':
                    // Preset 2 - White Card: white everywhere, base accents
                    frameColor = '#ffffff';
                    starMapColor = '#ffffff';
                    starsColor = baseColor;
                    outlineColor = baseColor;
                    textColor = baseColor;
                    break;
                case 'inner-filled':
                    // Preset 3 - White Card, Colored Sky: white frame, base sky, base accents
                    frameColor = '#ffffff';
                    starMapColor = baseColor;
                    starsColor = '#ffffff';
                    outlineColor = baseColor;
                    textColor = baseColor;
                    break;
                case 'ring':
                    // Preset 4 - Colored Card, White Sky: base frame, white sky, white accents
                    frameColor = baseColor;
                    starMapColor = '#ffffff';
                    starsColor = baseColor;
                    outlineColor = '#ffffff';
                    textColor = '#ffffff';
                    break;
            }

            // Apply colors using existing functions
            changeFrameColor(frameColor, textColor);
            changeStarMapColor(starMapColor, starsColor);

            // Explicitly set outline/border colors for all shapes
            applyOutlineColor(outlineColor);

            // Update hidden Star Map Color picker UI (for backend compatibility)
            updateColorPickerSelection('.star-map-color-picker', starMapColor);

            // Note: Don't update Base Color picker here - keep showing user's actual selection
            // The Base Color picker shows what user SELECTED, not what frame color BECAME

            console.log('Preset applied:', { preset, baseColor, frameColor, starMapColor, starsColor, outlineColor, textColor });
        }

        // Helper to update color picker selection visually
        function updateColorPickerSelection(pickerSelector, color) {
            const links = document.querySelectorAll(pickerSelector + ' .wrap a');
            links.forEach(l => l.classList.remove('current'));
            const match = document.querySelector(pickerSelector + ` .wrap a[data-color="${color}"]`);
            if (match) {
                match.classList.add('current');
            }
        }

        // Apply outline/border color to all shape types (circle, heart, compass)
        function applyOutlineColor(color) {
            // Get current shape
            const celestialMap = document.getElementById('celestial-map');
            const isCircle = celestialMap && celestialMap.classList.contains('shape-circle');
            const isHeart = celestialMap && celestialMap.classList.contains('shape-heart');

            // Target .bor elements in all shape contexts
            const borSelectors = [
                '#celestial-map.shape-circle .custom_iframe .bor',
                '#celestial-map.shape-heart .custom_iframe .bor',
                '#celestial-map.shape-compass .custom_iframe .bor',
                '.custom_iframe .bor',
                '.bor'
            ];

            borSelectors.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => {
                    el.style.setProperty('fill', color, 'important');
                    // Circle and heart: stroke none, Compass: stroke with color
                    if (isCircle || isHeart) {
                        el.style.setProperty('stroke', color, 'important');
                    } else {
                        el.style.setProperty('stroke', color, 'important');
                        document.querySelector('.compass-border').style.setProperty('stroke', color, 'important');
                    }
                });
            });

            // strokeCouple elements - same logic
            document.querySelectorAll('.strokeCouple').forEach(el => {
                if (isCircle || isHeart) {
                    el.style.setProperty('stroke', color, 'important');
                } else {
                    el.style.setProperty('stroke', color, 'important');
                    document.querySelector('.compass-border').style.setProperty('stroke', color, 'important');
                }
            });

            console.log('Outline color applied:', color, 'Shape:', isCircle ? 'circle' : isHeart ? 'heart' : 'compass');
        }

        // Legacy function for compatibility - now calls applyPresetWithBaseColor
        function applyMapStyle(style) {
            applyPresetWithBaseColor(style, currentBaseColor);
        }

        // Initialize unified color system on page load
        (function initializeUnifiedColorSystem() {
            // Get initially selected base color from Frame Color picker
            const initialBaseColorLink = document.querySelector('.frame-color-picker .wrap a.current');
            if (initialBaseColorLink) {
                currentBaseColor = initialBaseColorLink.getAttribute('data-color') || '#000000';
            }

            // Get initially selected preset from Map Style picker
            const initialPresetOption = document.querySelector('.map-style-option.current');
            if (initialPresetOption) {
                currentPreset = initialPresetOption.getAttribute('data-style') || 'inner-filled';
            }

            // Set initial data-preset attribute for CSS
            const starmapCustomizer = document.querySelector('.starmap-customizer');
            if (starmapCustomizer) {
                starmapCustomizer.setAttribute('data-preset', currentPreset);
            }

            // Apply initial colors with unified system
            applyPresetWithBaseColor(currentPreset, currentBaseColor);

            console.log('Unified color system initialized:', { preset: currentPreset, baseColor: currentBaseColor });
        })();

        // Border toggle (checkbox)
        const borderToggle = document.getElementById('enable-frame-border');
        if (borderToggle) {
            borderToggle.addEventListener('change', function() {
                updateFrameBorder();
            });
        }

        // Border picker (visual icons - like citymap)
        const borderOptions = document.querySelectorAll('.border__picker .border-options a');
        borderOptions.forEach(function(option) {
            option.addEventListener('click', function(e) {
                e.preventDefault();

                // Update visual selection using CSS class (same as citymap)
                borderOptions.forEach(o => o.classList.remove('current'));
                this.classList.add('current');

                // Update checkbox state based on selection
                const borderValue = this.getAttribute('data-border');
                const showBorder = borderValue === 'with';

                if (borderToggle) {
                    borderToggle.checked = showBorder;
                    updateFrameBorder();
                }

                // Also sync the icon toggle in starmap-elements-picker if it exists
                const iconToggle = document.querySelector('.starmap-elements-picker .celestial-toggle[data-toggle="enable-frame-border"]');
                if (iconToggle) {
                    if (showBorder) {
                        iconToggle.classList.add('active__picker');
                    } else {
                        iconToggle.classList.remove('active__picker');
                    }
                }
            });
        });

        // Star Map Elements icon toggles (Skylit style)
        const celestialToggles = document.querySelectorAll('.starmap-elements-picker .celestial-toggle');
        celestialToggles.forEach(function(toggle) {
            toggle.addEventListener('click', function() {
                const checkboxId = this.getAttribute('data-toggle');
                const checkbox = document.getElementById(checkboxId);

                if (checkbox) {
                    // Toggle checkbox state
                    checkbox.checked = !checkbox.checked;

                    // Toggle active class on icon
                    this.classList.toggle('active__picker');

                    // Trigger change event on checkbox
                    checkbox.dispatchEvent(new Event('change'));

                    // If this is the border toggle, sync with the border picker
                    if (checkboxId === 'enable-frame-border') {
                        const borderPickerOptions = document.querySelectorAll('.border__picker .border-options a');
                        borderPickerOptions.forEach(o => o.classList.remove('current'));
                        const targetSelector = checkbox.checked ? '[data-border="with"]' : '[data-border="without"]';
                        const targetOption = document.querySelector('.border__picker .border-options a' + targetSelector);
                        if (targetOption) {
                            targetOption.classList.add('current');
                        }
                    }
                }
            });
        });
    }

    // Update frame border based on toggle state
    // Border color follows the preset text color (per client specifications)
    function updateFrameBorder() {
        const borderToggle = document.getElementById('enable-frame-border');
        const frameContainer = document.querySelector('.frame-container');

        if (!frameContainer) return;

        const showBorder = borderToggle ? borderToggle.checked : false;

        if (showBorder) {
            // Get border color based on current preset (follows text/outline color)
            let borderColor = '#ffffff';

            switch(currentPreset) {
                case 'filled':
                    // Preset 1: White border
                    borderColor = '#ffffff';
                    break;
                case 'outline':
                    // Preset 2: Base color border
                    borderColor = currentBaseColor;
                    break;
                case 'inner-filled':
                    // Preset 3: Base color border
                    borderColor = currentBaseColor;
                    break;
                case 'ring':
                    // Preset 4: White border
                    borderColor = '#ffffff';
                    break;
            }

            frameContainer.style.border = '2px solid ' + borderColor;
        } else {
            frameContainer.style.border = 'none';
        }
    }

    // Shape mapping: shape name to textarea ID
    const shapeMap = {
        'circle': 'abc_6',
        'heart': 'abc_2',
        'compass': 'abc_10'
    };

    function changeShape(shape) {
        const textareaId = shapeMap[shape] || shapeMap['circle'];
        const textarea = document.getElementById(textareaId);
        const customIframe = document.querySelector('.custom_iframe');
        const celestialMap = document.getElementById('celestial-map');

        // FIRST: Add shape class to #celestial-map (before applying colors)
        if (celestialMap) {
            celestialMap.classList.remove('shape-circle', 'shape-heart', 'shape-compass');
            celestialMap.classList.add('shape-' + shape);
        }

        // THEN: Update SVG and apply colors
        if (textarea && customIframe) {
            customIframe.innerHTML = textarea.value;
            // Re-apply colors based on current preset (unified color system)
            reapplyCurrentPreset();
        }

        // Update hidden field for layout shape
        const hidden = document.getElementById('starmap-layout-shape');
        if (hidden) hidden.value = shape;
    }

    // Apply current style colors to the SVG shape (preserves current selections)
    function applyShapeColors() {
        const customFrame = document.querySelector('.custom-frame.bg-new');

        // Get current frame background color from DOM or use default
        let bgColor = '#000000';
        let textColor = '#ffffff';

        // Check if frame color picker has a selection
        const frameColorLink = document.querySelector('.frame-color-picker .wrap a.current');
        if (frameColorLink) {
            const selectedColor = frameColorLink.getAttribute('data-color');
            if (selectedColor) {
                bgColor = selectedColor;
            } else {
                // Custom color picker
                const customColorInput = document.getElementById('custom-color-frame');
                if (customColorInput) {
                    bgColor = customColorInput.value;
                }
            }
        } else if (customFrame && customFrame.style.backgroundColor) {
            // Fallback to current frame background
            bgColor = customFrame.style.backgroundColor;
        }

        // Calculate text color based on background brightness
        const isLight = lightOrDark(bgColor) === 'light';
        textColor = isLight ? '#000000' : '#ffffff';

        // Apply colors to SVG shape elements (.cust fills with frame color)
        const custElements = document.querySelectorAll('.editor-color-53 .cust, .editor-color-53 .stBg');
        custElements.forEach(el => {
            el.style.fill = bgColor;
        });

        // Set border/stroke colors - follows text color
        const borElements = document.querySelectorAll('.bor');
        const strokeElements = document.querySelectorAll('.strokeCouple');

        borElements.forEach(el => {
            el.style.setProperty('fill', textColor, 'important');
            el.style.setProperty('stroke', textColor, 'important');
        });
        strokeElements.forEach(el => {
            el.style.setProperty('stroke', textColor, 'important');
        });

        // Update compass border if present
        const compassBorder = document.querySelector('.compass-border');
        if (compassBorder) {
            compassBorder.setAttribute('stroke', textColor);
            compassBorder.style.setProperty('stroke', textColor, 'important');
        }
    }

    // Change Star Map (Celestial canvas) background color
    // starsColor param: if provided, uses explicit color for stars/text (per preset system)
    // If not provided, calculates from background color for backwards compatibility
    function changeStarMapColor(color, starsColor = null) {
        // Use explicit starsColor if provided, otherwise calculate from background
        const textColor = starsColor || (lightOrDark(color) === 'light' ? '#000000' : '#ffffff');
        // Constellation line color follows starsColor (per client preset requirements)
        // Use same color as stars, with slight opacity for visual distinction
        const lineColor = textColor;

        // Update Celestial.js with all color settings at once
        // Preserve current checkbox states for names
        const showConstellationNames = document.getElementById('show-constellation-names')?.checked || false;
        const showStarNames = document.getElementById('show-star-names')?.checked || false;

        const config = {
            background: { fill: color },
            stars: {
                style: { fill: textColor },
                designation: false,
                designationStyle: { fill: "transparent", font: "0px serif" },
                propername: showStarNames,
                propernameStyle: {
                    fill: showStarNames ? textColor : "transparent",
                    font: showStarNames ? "12px 'Palatino Linotype', Georgia, serif" : "0px serif"
                },
                propernameLimit: showStarNames ? 2.5 : -100
            },
            constellations: {
                names: showConstellationNames,
                namesType: "de",
                nameLimit: showConstellationNames ? -6 : -100,
                lineStyle: { stroke: lineColor },
                nameStyle: {
                    fill: showConstellationNames ? textColor : "transparent",
                    opacity: showConstellationNames ? 0.8 : 0,
                    font: showConstellationNames
                        ? ["20px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif"]
                        : ["0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif"]
                }
            },
            lines: {
                graticule: { stroke: lineColor }
            },
            mw: {
                style: { fill: textColor, opacity: 0.15 }
            }
        };

        if (typeof Celestial !== 'undefined') {
            Celestial.apply(config);
        }

        console.log('Star map color changed to:', color, 'Stars color:', textColor);
    }

    // Change Frame background color
    // explicitTextColor param: if provided, uses explicit color for text (per preset system)
    // If not provided, calculates from background color for backwards compatibility
    // Note: Outline colors are handled separately by applyOutlineColor()
    function changeFrameColor(color, explicitTextColor = null) {
        const customFrame = document.querySelector('.custom-frame.bg-new');
        if (customFrame) {
            customFrame.style.backgroundColor = color;
        }

        // Use explicit textColor if provided, otherwise calculate from background
        const textColor = explicitTextColor || (lightOrDark(color) === 'light' ? '#000000' : '#ffffff');

        console.log('Frame color:', color, 'Text color:', textColor);

        // Update frame text color
        if (customFrame) {
            customFrame.style.color = textColor;
        }

        // Update preview title and subtitle text colors
        const previewTitle = document.getElementById('preview-title');
        const previewSubtitle = document.getElementById('preview-subtitle');
        if (previewTitle) {
            previewTitle.style.color = textColor;
            previewTitle.style.setProperty('color', textColor, 'important');
        }
        if (previewSubtitle) {
            previewSubtitle.style.color = textColor;
            previewSubtitle.style.setProperty('color', textColor, 'important');
        }

        // Update all text elements in custom-textarea
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.style.color = textColor;
            customTextarea.style.setProperty('color', textColor, 'important');
            // Also update all child elements
            customTextarea.querySelectorAll('*').forEach(el => {
                el.style.setProperty('color', textColor, 'important');
            });
        }

        // Update frame container text
        const frameContainer = document.querySelector('.frame-container');
        if (frameContainer) {
            frameContainer.style.setProperty('color', textColor, 'important');
        }

        // Update SVG shape fill colors (background of shape area, not outline)
        const custElements = document.querySelectorAll('.editor-color-53 .cust, .editor-color-53 .stBg');
        custElements.forEach(el => {
            el.style.fill = color;
        });

        // Note: Outline/border colors (.bor, .strokeCouple, compass elements) are now
        // handled by applyOutlineColor() which is called after this function
        // This ensures preset colors take precedence over auto-contrast

        // Update frame border if enabled
        updateFrameBorder();
    }

    // Update Celestial.js constellation, grid, and text colors
    function updateCelestialColors(textColor) {
        if (typeof Celestial === 'undefined') return;

        const lineColor = textColor === '#000000' ? '#333333' : '#cccccc';

        const config = {
            constellations: {
                lineStyle: { stroke: lineColor },
                nameStyle: { fill: textColor }
            },
            lines: {
                graticule: { stroke: lineColor }
            },
            stars: {
                designationStyle: { fill: textColor },
                propernameStyle: { fill: textColor }
            },
            mw: {
                style: { fill: textColor, opacity: 0.15 }
            }
        };

        Celestial.apply(config);
    }

    // Flag to track if animations have been enabled (only enable once)
    var animationsEnabled = false;

    function enableAnimationsOnce() {
        if (!animationsEnabled && typeof Celestial !== 'undefined' && Celestial.apply) {
            Celestial.apply({ disableAnimations: false });
            animationsEnabled = true;
        }
    }

    function updateCelestialDateTime() {
        const dateInput = document.getElementById('starmap-date-input');
        const timeInput = document.getElementById('starmap-time-input');

        if (!dateInput || !dateInput.value) return;

        const dateParts = dateInput.value.split('-');
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1; // JS months are 0-indexed
        const day = parseInt(dateParts[2]);

        let hours = 21; // Default 9 PM
        let minutes = 0;

        if (timeInput && timeInput.value) {
            const timeParts = timeInput.value.split(':');
            hours = parseInt(timeParts[0]);
            minutes = parseInt(timeParts[1]);
        }

        const date = new Date(year, month, day, hours, minutes);
        const timezone = Celestial.timezone ? Celestial.timezone() : null;

        enableAnimationsOnce();
        Celestial.date(date, timezone);
        Celestial.location([currentLat, currentLng]);

        // Update hidden form fields
        const dateHidden = document.getElementById('starmap-date');
        const timeHidden = document.getElementById('starmap-time');
        if (dateHidden) dateHidden.value = dateInput.value;
        if (timeHidden) timeHidden.value = timeInput ? timeInput.value : '21:00';
    }

    function updateCelestialLocation(lat, lng) {
        currentLat = lat;
        currentLng = lng;
        enableAnimationsOnce();
        Celestial.location([lat, lng]);
    }

    function updateLocationFields(address, lat, lng) {
        const locationHidden = document.getElementById('starmap-location');
        const coordsHidden = document.getElementById('starmap-coordinates');

        if (locationHidden) locationHidden.value = address;
        if (coordsHidden) coordsHidden.value = `${lat.toFixed(4)}, ${lng.toFixed(4)}`;
    }

    function updateConstellations(show) {
        const namesCheckbox = document.getElementById('show-constellation-names');
        const showNames = namesCheckbox ? namesCheckbox.checked : false;
        const config = {
            constellations: {
                show: show,
                lines: show,
                names: showNames
            }
        };
        Celestial.apply(config);

        // Update hidden field
        const hidden = document.getElementById('starmap-constellations');
        if (hidden) hidden.value = show ? 'Yes' : 'No';
    }

    function updateConstellationNames(show) {
        const textColor = getCurrentStarMapContrastColor(true);
        const config = {
            constellations: {
                show: document.getElementById('show-constellations')?.checked || false,
                names: show,
                namesType: "de",
                nameLimit: show ? -6 : -100,  // -6 shows only major constellations like Orion, Ursa Major, etc.
                nameStyle: {
                    fill: show ? textColor : "transparent",
                    align: "center",
                    baseline: "middle",
                    opacity: show ? 0.8 : 0,
                    font: show
                        ? ["20px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif", "15px Open Sans, Arial, sans-serif"]
                        : ["0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif", "0px Open Sans, Arial, sans-serif"]
                }
            }
        };
        Celestial.apply(config);
    }

    function updateStarNames(show) {
        // Get current star map color to determine text color
        const textColor = getCurrentStarMapContrastColor(true);

        const config = {
            stars: {
                // Proper names only (e.g., "Sirius", "Betelgeuse")
                // Per client request: show proper names in German, NOT designations (α Ori)
                propername: show,
                propernameType: "de",
                propernameStyle: {
                    fill: textColor,
                    font: show ? "12px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif" : "0px 'Palatino Linotype', Georgia, Times, 'Times Roman', serif",
                    align: "right",
                    baseline: "bottom"
                },
                propernameLimit: show ? 2.5 : -100,
                // Designations disabled per client request
                designation: false,
                designationType: "desig",
                designationStyle: {
                    fill: "transparent",
                    font: "0px serif",
                    align: "left",
                    baseline: "top"
                },
                designationLimit: -100
            }
        };
        Celestial.apply(config);

        // Update hidden field
        const hidden = document.getElementById('starmap-star-names');
        if (hidden) hidden.value = show ? 'Yes' : 'No';

        console.log('Star names toggled:', show, '(proper names only)');
    }

    function updateGrid(show) {
        // Get current star map color to determine grid color
        const gridColor = getCurrentStarMapContrastColor();

        const config = {
            lines: {
                graticule: { show: show, stroke: gridColor }
            }
        };
        Celestial.apply(config);

        // Update hidden field
        const hidden = document.getElementById('starmap-grid');
        if (hidden) hidden.value = show ? 'Yes' : 'No';
    }

    function updateMilkyWay(show) {
        // Get current star map color to determine milky way color
        const mwColor = getCurrentStarMapContrastColor(true);

        const config = {
            mw: { show: show, style: { fill: mwColor, opacity: 0.15 } }
        };
        Celestial.apply(config);
    }

    // Helper function to get contrast color based on current star map background
    function getCurrentStarMapContrastColor(isText) {
        // Check current star map color from color picker
        const starMapColorLink = document.querySelector('.star-map-color-picker .wrap a.current');
        let bgColor = '#000000'; // Default dark

        if (starMapColorLink) {
            const selectedColor = starMapColorLink.getAttribute('data-color');
            if (selectedColor) {
                bgColor = selectedColor;
            } else {
                // Custom color picker
                const customColorInput = document.getElementById('custom-color-starmap');
                if (customColorInput) {
                    bgColor = customColorInput.value;
                }
            }
        }

        const isLight = lightOrDark(bgColor) === 'light';

        if (isText) {
            return isLight ? '#000000' : '#ffffff';
        }
        return isLight ? '#333333' : '#cccccc';
    }

    function updatePreviewTitle(text) {
        const previewTitle = document.getElementById('preview-title');
        if (previewTitle) previewTitle.textContent = text;

        // Update hidden field
        const hidden = document.getElementById('starmap-title-large');
        if (hidden) hidden.value = text;

        // Adjust font size based on content
        adjustTextareaFontSize();
    }

    function updatePreviewSubtitle(text) {
        const previewSubtitle = document.getElementById('preview-subtitle');
        if (previewSubtitle) previewSubtitle.textContent = text;

        // Update hidden field
        const hidden = document.getElementById('starmap-title-small');
        if (hidden) hidden.value = text;

        // Adjust font size based on content
        adjustTextareaFontSize();
    }

    // Initialize Text & Labels inputs
    function initTextLabelInputs() {
        // Message textarea
        const messageInput = document.getElementById('textMessage');
        if (messageInput) {
            messageInput.addEventListener('input', function() {
                // Limit to 3 lines max
                const lines = this.value.split('\n');
                if (lines.length > 3) {
                    this.value = lines.slice(0, 3).join('\n');
                }

                const charCount = this.value.length;
                const countLabel = document.getElementById('message-char-count');
                if (countLabel) countLabel.textContent = charCount + '/100';
                updatePreviewFromInputs();
            });
            // Initialize char count
            const charCount = messageInput.value.length;
            const countLabel = document.getElementById('message-char-count');
            if (countLabel) countLabel.textContent = charCount + '/100';
        }

        // Date input with toggle
        const dateInput = document.getElementById('textDate');
        const dateToggle = document.getElementById('toggle-date');
        if (dateInput) {
            dateInput.addEventListener('input', function() {
                updatePreviewFromInputs();
            });
        }
        if (dateToggle) {
            dateToggle.addEventListener('change', function() {
                const inputMain = dateInput?.closest('.row__input--main');
                if (inputMain) {
                    if (this.checked) {
                        inputMain.classList.remove('disabled__row');
                        dateInput.disabled = false;
                    } else {
                        inputMain.classList.add('disabled__row');
                        dateInput.disabled = true;
                    }
                }
                updatePreviewFromInputs();
            });
        }

        // Location input with toggle
        const locationInput = document.getElementById('textLocation');
        const locationToggle = document.getElementById('toggle-location');
        if (locationInput) {
            locationInput.addEventListener('input', function() {
                updatePreviewFromInputs();
            });
        }
        if (locationToggle) {
            locationToggle.addEventListener('change', function() {
                const inputMain = locationInput?.closest('.row__input--main');
                if (inputMain) {
                    if (this.checked) {
                        inputMain.classList.remove('disabled__row');
                        locationInput.disabled = false;
                    } else {
                        inputMain.classList.add('disabled__row');
                        locationInput.disabled = true;
                    }
                }
                updatePreviewFromInputs();
            });
        }

        // Coordinates input with toggle
        const coordsInput = document.getElementById('textCoordinates');
        const coordsToggle = document.getElementById('toggle-coordinates');
        if (coordsInput) {
            coordsInput.addEventListener('input', function() {
                updatePreviewFromInputs();
            });
        }
        if (coordsToggle) {
            coordsToggle.addEventListener('change', function() {
                const inputMain = coordsInput?.closest('.row__input--main');
                if (inputMain) {
                    if (this.checked) {
                        inputMain.classList.remove('disabled__row');
                        coordsInput.disabled = false;
                    } else {
                        inputMain.classList.add('disabled__row');
                        coordsInput.disabled = true;
                    }
                }
                updatePreviewFromInputs();
            });
        }

        // Initialize preview with default values
        updatePreviewFromInputs();
    }

    // Update preview from all text inputs
    function updatePreviewFromInputs() {
        const message = document.getElementById('textMessage')?.value || '';
        const dateToggle = document.getElementById('toggle-date');
        const locationToggle = document.getElementById('toggle-location');
        const coordsToggle = document.getElementById('toggle-coordinates');

        const date = dateToggle?.checked ? (document.getElementById('textDate')?.value || '') : '';
        const location = locationToggle?.checked ? (document.getElementById('textLocation')?.value || '') : '';
        const coords = coordsToggle?.checked ? (document.getElementById('textCoordinates')?.value || '') : '';

        // Update custom-textarea with message — CSS macht den Wrap, JS shrinkt Font.
        const customTextarea = document.querySelector('.custom-textarea.my-1.w-100');
        if (customTextarea) {
            // Hard cap auf 100 chars (HTML maxlength wird via URL-Param umgangen).
            const safeMessage = (message || '').substring(0, 100);

            // User-Newlines als <br> erhalten, kein char-chunking — CSS bricht an Wortgrenzen.
            customTextarea.innerHTML = escapeHtml(safeMessage).replace(/\n/g, '<br>');

            // Font-Size auto-shrink: 100 Zeichen sollen in 3 Zeilen passen.
            const charCount = safeMessage.replace(/\s+/g, ' ').trim().length;
            let fontSize;
            if      (charCount <= 30)  fontSize = '18pt';
            else if (charCount <= 60)  fontSize = '16pt';
            else if (charCount <= 90)  fontSize = '14pt';
            else                       fontSize = '12pt';
            customTextarea.style.setProperty('font-size', fontSize, 'important');

            // Kein Zeilen-Clamp und kein overflow: hidden mehr (12.09.2026): der Render-Server
            // (starmap_frontend/js/starmap-celestial.js) hat diesen Block nicht und druckt mit
            // overflow: visible — der Clamp schnitt Script-Schriften (Parlare, Lobster, Great
            // Vibes) nur in der Vorschau ab. Die Drei-Zeilen-Grenze sichert das Eingabefeld.
            customTextarea.style.removeProperty('display');
            customTextarea.style.removeProperty('-webkit-line-clamp');
            customTextarea.style.removeProperty('-webkit-box-orient');
            customTextarea.style.setProperty('overflow', 'visible', 'important');
            customTextarea.style.setProperty('word-break', 'normal', 'important');
            customTextarea.style.setProperty('overflow-wrap', 'break-word', 'important');
        }

        // Update custom-address with date, location, coords
        const customAddress = document.querySelector('.custom-address');
        if (customAddress) {
            let addressParts = [];
            if (date) addressParts.push(date);
            if (location) addressParts.push(location);
            if (coords) addressParts.push(coords);
            customAddress.innerHTML = addressParts.map(p => escapeHtml(p)).join('<br>');
        }

        // Adjust font size based on content
        adjustTextareaFontSize();
    }

    // Helper to escape HTML
    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    // Update preview font - exposed globally for starmap.js to call
    window.updatePreviewFont = function(fontFamily) {
        // Update custom-frame and all its children
        const customFrame = document.querySelector('.starmap-customizer .canvas__wrapper .single-map-view .custom-frame');
        if (customFrame) {
            customFrame.style.fontFamily = fontFamily + ', sans-serif';
            customFrame.querySelectorAll('*').forEach(el => {
                el.style.fontFamily = fontFamily + ', sans-serif';
            });
        }

        // Update preview title and subtitle fonts
        const previewTitle = document.getElementById('preview-title');
        const previewSubtitle = document.getElementById('preview-subtitle');
        const customTextarea = document.querySelector('.custom-textarea');

        if (previewTitle) {
            previewTitle.style.fontFamily = fontFamily + ', sans-serif';
        }
        if (previewSubtitle) {
            previewSubtitle.style.fontFamily = fontFamily + ', sans-serif';
        }
        if (customTextarea) {
            customTextarea.style.fontFamily = fontFamily + ', sans-serif';
            customTextarea.querySelectorAll('*').forEach(el => {
                el.style.fontFamily = fontFamily + ', sans-serif';
            });
        }

        // Update hidden field
        const hidden = document.getElementById('starmap-font');
        if (hidden) hidden.value = fontFamily;

        console.log('Font changed to:', fontFamily);
    };

    function updateCharCount(elementId, count) {
        const el = document.getElementById(elementId);
        if (el) el.textContent = count;
    }

    // Auto-adjust font size based on total character count in custom-textarea
    function adjustTextareaFontSize() {
        const customTextarea = document.querySelector('.custom-textarea');
        if (!customTextarea) return;

        const text = customTextarea.textContent || customTextarea.innerText || '';
        const charCount = text.replace(/\s+/g, ' ').trim().length;

        let fontSize;
        if (charCount <= 30) {
            fontSize = '16pt';
        } else if (charCount <= 50) {
            fontSize = '14pt';
        } else if (charCount <= 70) {
            fontSize = '13pt';
        } else if (charCount <= 100) {
            fontSize = '12pt';
        } else if (charCount <= 130) {
            fontSize = '11pt';
        } else {
            fontSize = '10pt';
        }

        customTextarea.style.setProperty('font-size', fontSize, 'important');
    }

    /* Standardschrift beim Laden setzen (12.09.2026, Dominik). Bis dahin blieb das versteckte
       Feld #starmap-font leer, bis jemand eine Kachel anklickte: der Job trug `font: ""`, die
       Kachel „Satoshi" stand als aktiv markiert, gezeichnet und gedruckt wurde aber Spectral
       (Inline-Stil am Rahmen im Theme, `config.font || 'Spectral'` in print-mode.js auf dem
       Render-Server). Jetzt ist Spectral die markierte Kachel, und ihr Name geht von Anfang an
       ins Feld und in die Vorschau — jeder Job traegt die Schrift explizit, Vorschau, Warenkorb
       (`Font Family`) und Druck meinen dieselbe. Massgeblich ist die als `current` markierte
       Kachel im Markup, nicht ein Name im Skript: Kachel und Standard koennen so nie auseinander-
       laufen. Ein bereits gefuelltes Feld (Preset, Bearbeiten-Modus) bleibt unangetastet. */
    function standardSchriftSetzen() {
        var feld = document.getElementById('starmap-font');
        if (feld && feld.value) return;
        var kachel = document.querySelector('.starmap-customizer .font__picker .font-options-grid li a.current[data-font]');
        if (!kachel) return;
        var schrift = kachel.getAttribute('data-font');
        if (!schrift) return;
        if (typeof window.updatePreviewFont === 'function') window.updatePreviewFont(schrift);
        else if (feld) feld.value = schrift;
    }

    function applyStylePreset(styleName) {
        const preset = stylePresets[styleName];
        if (!preset) return;

        // Update Celestial colors
        const config = {
            background: { fill: preset.background },
            stars: { style: { fill: preset.stars } },
            constellations: {
                lineStyle: { stroke: preset.lines },
                nameStyle: { fill: preset.text }
            }
        };
        Celestial.apply(config);

        // Update preview container background
        const container = document.querySelector('.starmap-customizer .custom-frame');
        if (container) {
            container.style.backgroundColor = preset.background;
            container.style.color = preset.text;
        }

        // Update hidden field
        const hidden = document.getElementById('starmap-style');
        if (hidden) hidden.value = styleName;
    }

    // Light/dark color detection
    function lightOrDark(color) {
        let r, g, b;

        if (color.match(/^rgb/)) {
            color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
            r = color[1];
            g = color[2];
            b = color[3];
        } else {
            color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));
            r = color >> 16;
            g = (color >> 8) & 255;
            b = color & 255;
        }

        const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
        return hsp > 127.5 ? 'light' : 'dark';
    }

    /**
     * Show print preview in a modal dialog (like citymap)
     * Called by "Druckvorschau laden" button
     */
    window.showStarmapPreviewModal = async function(event) {
        if (event) event.preventDefault();

        const modal = document.getElementById('print-preview-modal');
        if (!modal) return;

        const spinner = modal.querySelector('.print-preview-modal__spinner');
        const image = modal.querySelector('.print-preview-modal__image');
        const errorEl = modal.querySelector('.print-preview-modal__error');
        const cartBtn = modal.querySelector('.print-preview-modal__btn-cart');

        // Reset state
        if (spinner) spinner.style.display = 'block';
        if (image) image.style.display = 'none';
        if (errorEl) errorEl.style.display = 'none';
        if (cartBtn) {
            cartBtn.style.pointerEvents = 'auto';
            cartBtn.textContent = cartBtn.dataset.originalText || cartBtn.textContent;
        }

        // Show modal in top-layer (fixes iOS WebGL z-index)
        modal.showModal();
        document.body.style.overflow = 'hidden';

        try {
            // Get current configuration
            const config = gatherStarmapConfig();

            // Get selected size info for dimensions (nur SICHTBARES Panel, Fix 24.08.2026)
            const selectedSize = getVisibleSizeCurrent();
            const paperSize = selectedSize ? selectedSize.getAttribute('data-size') : '30x40cm';

            // Parse paper size
            let widthCm = 30, heightCm = 40;
            try {
                const sizeParts = paperSize.toLowerCase().replace('cm', '').split('x');
                widthCm = parseFloat(sizeParts[0]);
                heightCm = parseFloat(sizeParts[1]);
            } catch (e) {
                console.warn('Could not parse paper size, using defaults');
            }

            // Build preview config with 72 DPI
            const previewConfig = {
                ...config,
                order_id: order_id,
                print: {
                    width: widthCm,
                    height: heightCm,
                    dpi: 72
                }
            };

            console.log('Generating starmap preview:', previewConfig);

            // Call preview endpoint
            const response = await fetch(`${BACKEND_API_URL}/preview/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(previewConfig)
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(errorData?.error || `Server returned ${response.status}`);
            }

            const result = await response.json();

            if (result.success && result.imageUrl) {
                const imageUrl = result.imageUrl + '?t=' + Date.now();

                // Preload image before showing
                const img = new Image();
                img.onload = function() {
                    if (spinner) spinner.style.display = 'none';
                    if (image) {
                        image.src = imageUrl;
                        image.style.display = 'block';
                    }
                };
                img.onerror = function() {
                    if (spinner) spinner.style.display = 'none';
                    if (errorEl) {
                        errorEl.textContent = 'Bild konnte nicht geladen werden.';
                        errorEl.style.display = 'block';
                    }
                };
                img.src = imageUrl;

                // Store preview URL for cart (so it shows in cart as item image)
                window.starmapPreviewImageUrl = imageUrl;

                console.log(`Starmap preview generated in ${result.renderTime?.toFixed(2)}s`);
            } else {
                throw new Error(result.error || 'Preview generation failed');
            }

        } catch (error) {
            console.error('Error generating starmap preview:', error);
            if (spinner) spinner.style.display = 'none';
            if (errorEl) {
                errorEl.textContent = 'Vorschau konnte nicht geladen werden: ' + error.message;
                errorEl.style.display = 'block';
            }
        }
    };

    window.generateStarmapAndAddToCart = async function(event) {
        event.preventDefault();

        /* PROJ-99 (I1): Solange cart-edit.js den gespeicherten Zustand laedt und anwendet, ist
           der Knopf gesperrt. Die Flagge ist hier NICHT optional: das Druckvorschau-Modal
           dieser Datei klickt den Warenkorb-Knopf programmatisch (`cartBtn.click()`), und davon
           weiss `pointer-events: none` nichts. Ohne die Sperre legte ein Klick in diesem
           Fenster den DEFAULT-Stand ein, und abschliessen() raeumte danach die Zeile mit dem
           Kundenmotiv weg. */
        if (window.DLCartEdit && window.DLCartEdit.istGesperrt()) return;

        // Validate required fields
        const dateInput = document.getElementById('starmap-date-input');
        const locationInput = document.getElementById('starmap-location-input');

        if (!dateInput?.value) {
            showToast('Bitte wähle ein Datum für deine Sternenkarte.');
            return;
        }

        if (!locationInput?.value) {
            showToast('Bitte gib einen Ort für deine Sternenkarte ein.');
            return;
        }

        // Show loading state
        const addToCartBtn = document.querySelector('.starmap-customizer .bottom__controls .btn > a');
        const originalBtnText = addToCartBtn ? addToCartBtn.innerHTML : '';
        if (addToCartBtn) {
            addToCartBtn.innerHTML = '<span>Wird verarbeitet...</span>';
            addToCartBtn.style.pointerEvents = 'none';
        }

        /* PROJ-99 Task D — Befund: der Selektor eine Zeile darueber trifft im aktuellen Markup
           NICHTS. Der Knopf steht in `.bottom__controls .btn-group > a.cart-btn`, gesucht wird
           `.btn > a`. Der Ladezustand und die Klicksperre sind damit seit dem Markup-Umbau tot.
           Hier bewusst NICHT gefixt: mit heilem Selektor bliebe der Knopftext nach dem Einlegen
           dauerhaft auf „✓ Zum Warenkorb hinzugefuegt!" stehen (anders als citymap.js hat diese
           Datei keinen Ruecksetz-Timeout) — das waere eine sichtbare Aenderung am Normalmodus
           und gehoert in eine eigene Aufgabe. Fuer den Bearbeiten-Modus wird der ECHTE Knopf
           hier gesperrt: ohne Sperre legt ein Doppelklick zwei neue Zeilen an und entfernt nur
           eine alte. */
        const bearbeitenKnopf = (window.DLCartEdit && window.DLCartEdit.familie === 'starmap')
            ? document.querySelector('.starmap-customizer .cart-btn')
            : null;
        if (bearbeitenKnopf) bearbeitenKnopf.style.pointerEvents = 'none';

        try {
            // Generate new job ID for this order
            order_id = generateUUID();

            // Gather configuration
            /* PROJ-99 Task D: Der Bau der Backend-Config (Groesse -> DPI -> Pixelmasse -> print)
               lag hier inline. Er ist WORTGLEICH nach window.backendConfigSammeln() gezogen,
               damit konfigurationAnwenden() ein Gegenstueck hat und der Round-Trip
               (anwenden -> sammeln -> gleich) ueberhaupt pruefbar ist. `config` ist wie vorher
               genau das Ergebnis von gatherStarmapConfig() — also die Backend-Config OHNE den
               print-Block, der erst hier dazukommt. */
            const backendConfig = window.backendConfigSammeln();
            const config = Object.assign({}, backendConfig);
            delete config.print;

            console.log('Submitting starmap config to backend:', backendConfig);

            // Step 1: Submit to backend API
            const submitResponse = await fetch(`${BACKEND_API_URL}/render/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(backendConfig)
            });

            const submitResult = await submitResponse.json();
            console.log('Backend response:', submitResult);

            if (!submitResult.success) {
                throw new Error(submitResult.error || 'Sternenkarten-Konfiguration konnte nicht gesendet werden');
            }

            // Step 2: Build image URLs
            const imageUrl = `${BACKEND_API_URL}/data/${order_id}/`;
            const previewImageUrl = imageUrl; // Same URL, backend will redirect when ready

            // Step 3: Update config with URLs
            config.order_id = order_id;
            config._print_image_url = imageUrl;
            config._preview_image_url = previewImageUrl;

            // Populate all hidden form fields before submission
            populateHiddenFields(config);

            // Store config in hidden field
            const configHidden = document.getElementById('starmap-config-json');
            if (configHidden) {
                configHidden.value = JSON.stringify(config);
            }

            // Step 4: Add to Shopify cart
            await addToCartViaFetch(config);

        } catch (error) {
            console.error('Error generating starmap:', error);
            showToast('Fehler bei der Verarbeitung. Bitte versuche es erneut.');

            // Restore button
            if (addToCartBtn) {
                addToCartBtn.innerHTML = originalBtnText;
                addToCartBtn.style.pointerEvents = 'auto';
            }
            /* PROJ-99: im Bearbeiten-Modus den echten Knopf wieder freigeben — der Text bleibt
               „Änderung übernehmen", der Modus laeuft ja weiter. */
            if (bearbeitenKnopf) bearbeitenKnopf.style.pointerEvents = 'auto';
        }
    };

    // Populate all hidden form fields before form submission
    function populateHiddenFields(config) {
        const fields = {
            'starmap-date': config.date,
            'starmap-time': config.time,
            'starmap-location': config.location,
            'starmap-coordinates': config.coordinates,
            'starmap-style': config.style,
            'starmap-layout-type': config.layoutType,
            'starmap-layout-shape': config.layout,
            'starmap-title-large': config.title,
            'starmap-title-small': config.subtitle,
            'starmap-font': config.font,
            'starmap-constellations': config.showConstellations ? 'Yes' : 'No',
            'starmap-star-names': config.showStarNames ? 'Yes' : 'No',
            'starmap-grid': config.showGrid ? 'Yes' : 'No',
            'starmap-custom-colors': config.starMapColor ? `Map: ${config.starMapColor}, Frame: ${config.frameBackgroundColor}` : '',
            'starmap-frame': config.frame,
            'starmap-orientation': config.orientation,
            'starmap-paper-size': config.paperSize,
            'starmap-background-image': config.backgroundImage
        };

        for (const [id, value] of Object.entries(fields)) {
            const field = document.getElementById(id);
            if (field) field.value = value;
        }
    }

    // Groessen-Kachel NUR aus dem SICHTBAREN Produkttyp-Panel lesen (Fix 24.08.2026,
    // #1121/#1122): Jedes .el__format-Panel behaelt seine eigene a.current-Auswahl,
    // auch wenn es versteckt ist. Der alte globale querySelector nahm den ERSTEN
    // Treffer im DOM — also ggf. die alte Groesse eines versteckten Panels. Folge:
    // Variante/SKU korrekt (z.B. 30x40), Render-Config falsch (z.B. 50x70).
    function getVisibleSizeCurrent() {
        const panels = document.querySelectorAll('.starmap-customizer .el__format');
        for (const panel of panels) {
            if (panel.style.display === 'none') continue;
            const current = panel.querySelector('.size__picker a.current');
            if (current) return current;
        }
        // Fallback: altes Verhalten (sollte nie greifen, verhindert aber Totalausfall)
        return document.querySelector('.starmap-customizer .size__picker a.current');
    }

    function gatherStarmapConfig() {
        // Get BASE color from Base Color picker (this is what user selected)
        const baseColorLink = document.querySelector('.frame-color-picker .wrap a.current');
        let baseColor = '#000000';
        if (baseColorLink) {
            const customInput = baseColorLink.querySelector('input[type="color"]');
            baseColor = customInput ? customInput.value : (baseColorLink.getAttribute('data-color') || '#000000');
        }

        // Get current map style preset
        const mapStyleOption = document.querySelector('.map-style-option.current');
        const mapStyle = mapStyleOption ? mapStyleOption.getAttribute('data-style') : 'inner-filled';

        // Calculate ACTUAL colors based on preset (same logic as applyPresetWithBaseColor)
        const isBaseLight = lightOrDark(baseColor) === 'light';
        let frameColor, starMapColor;

        switch(mapStyle) {
            case 'filled':
                frameColor = baseColor;
                starMapColor = baseColor;
                break;
            case 'outline':
                frameColor = '#ffffff';
                starMapColor = '#ffffff';
                break;
            case 'inner-filled':
                frameColor = '#ffffff';
                starMapColor = baseColor;
                break;
            case 'ring':
                frameColor = baseColor;
                starMapColor = '#ffffff';
                break;
            default:
                frameColor = baseColor;
                starMapColor = baseColor;
        }

        // Get frame selection
        const frameLink = document.querySelector('.starmap-customizer .image__changer.frame-picker ul li a.current');
        const frame = frameLink ? (frameLink.getAttribute('data-frame-color') || 'none') : 'none';

        // Check if background image is enabled - use text color picker value
        const backgroundImage = document.getElementById('starmap-background-image')?.value || '';
        const hasBackground = !!backgroundImage;

        // Get text color: from picker if background enabled, otherwise calculate from frame color
        let textColor;
        if (hasBackground) {
            const textColorLink = document.querySelector('.text-color-picker .wrap a.current');
            textColor = textColorLink ? textColorLink.getAttribute('data-color') : '#ffffff';
        } else {
            textColor = lightOrDark(frameColor) === 'light' ? '#000000' : '#ffffff';
        }

        return {
            order_id: order_id,
            date: document.getElementById('starmap-date-input')?.value || '',
            time: document.getElementById('starmap-time-input')?.value || '21:00',
            location: document.getElementById('starmap-location-input')?.value || '',
            coordinates: `${currentLat}, ${currentLng}`,
            title: document.querySelector('.custom-textarea')?.innerHTML || '',
            subtitle: document.querySelector('.custom-address')?.innerHTML || '',
            // Echte gewaehlte Grundfarbe (Hex) statt totem Preset-Namen.
            // '#starmap-style' wurde nie befuellt und der alte Fallback
            // 'midnight-blue' stand irrefuehrend in den Bestell-Properties,
            // obwohl die Farben aus baseColor/mapStyle kommen (#1110, 03.08.2026).
            style: baseColor,
            mapStyle: mapStyle,  // Preset: filled, outline, inner-filled, ring
            showConstellations: document.getElementById('show-constellations')?.checked || false,
            showConstellationNames: document.getElementById('show-constellation-names')?.checked || false,
            showStarNames: document.getElementById('show-star-names')?.checked || false,
            showGrid: document.getElementById('show-grid')?.checked || false,
            showMilkyWay: document.getElementById('show-milky-way')?.checked || false,
            layout: document.querySelector('.starmap-customizer .elem__picker ul li a.current[data-layout]')?.getAttribute('data-layout') || 'circle',
            customImage: uploadedImageUrl || '',
            // Additional properties
            font: document.getElementById('starmap-font')?.value || '',
            frame: frame,
            orientation: document.getElementById('starmap-orientation')?.value || 'portrait',
            // Groesse aus dem Size-Picker (data-size der aktiven Kachel) —
            // '#starmap-paper-size' existiert nicht, die Property _Paper_Size
            // ging deshalb immer leer raus (stiller 30x40-Fallback, #1110).
            paperSize: getVisibleSizeCurrent()?.getAttribute('data-size') || '',
            layoutType: document.getElementById('starmap-layout-type')?.value || 'Poster',
            starMapColor: starMapColor,  // Calculated based on preset
            frameBackgroundColor: frameColor,  // Calculated based on preset
            baseColor: baseColor,  // Original user-selected base color
            mapStyle: mapStyle,  // Preset: filled, outline, inner-filled, ring
            textColor: textColor,  // From text color picker if background, otherwise calculated
            showBorder: document.getElementById('enable-frame-border')?.checked || false,
            backgroundImage: backgroundImage
        };
    }

    /* ==========================================================================================
       PROJ-99 Task D — Bearbeiten-Modus der Sternkarte
       ==========================================================================================
       Gegenstueck zu assets/cart-edit.js: der Helfer hat die Warenkorbzeile gelesen und den
       gespeicherten Zustand besorgt (bei der Sternkarte ueber `_job_id` vom Render-Server, also
       GENAU das Objekt, das unten an /api/v1/starmap/render/ geht). Hier wird er auf den Editor
       angewendet.

       Grundsatz wie bei der Stadtkarte (Task C): NICHT den Druckmodus nachbauen, sondern
       dieselben Kacheln und Felder bedienen, die der Kunde anklicken wuerde. Damit laufen alle
       bestehenden Folgewirkungen mit (Variante/Preis, Farb-Preset, Celestial-Neuzeichnung,
       Vorschau-Text, Rahmenbild) und die Oberflaeche ZEIGT den Zustand.
       ========================================================================================== */

    function dlWarte(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    /* Config-Werte landen in Selektoren. Sie kommen zwar vom eigenen Server, sind aber
       Kundendaten (Farbwert, Schrift, Rahmenfarbe, Produktart) — ein Anfuehrungszeichen darin
       wuerde den Selektor sprengen. Gleiche Loesung wie in citymap.js. */
    function dlSelektorWert(wert) {
        const text = String(wert == null ? '' : wert);
        if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(text);
        return text.replace(/["'\\\]]/g, '\\$&');
    }

    /* Klickt genau die Kachel, die der Kunde anklicken wuerde. Ist sie schon aktiv, passiert
       nichts — sonst wuerden Handler unnoetig doppelt laufen. */
    function dlKachelKlicken(kachel) {
        if (!kachel) return false;
        if (!kachel.classList.contains('current')) kachel.click();
        return true;
    }

    /* Das SICHTBARE Produkttyp-Panel — dieselbe Regel wie getVisibleSizeCurrent() (Fix
       24.08.2026, #1121/#1122): jedes .el__format behaelt seine eigene Groessen-Auswahl, auch
       wenn es versteckt ist. Ein globaler querySelector wuerde die Groesse eines versteckten
       Panels treffen. */
    function dlSichtbaresFormatPanel() {
        const panels = document.querySelectorAll('.starmap-customizer .el__format');
        for (const panel of panels) {
            if (panel.style.display === 'none') continue;
            return panel;
        }
        return null;
    }

    /* Checkbox setzen, die daran haengenden Handler ausloesen und das Icon-Kaestchen im
       „Star Map Elements"-Raster mitziehen — sonst zeigt die Oberflaeche den Zustand nicht.
       Bewusst NICHT das Icon klicken: dessen Handler kippt den Zustand, statt ihn zu setzen. */
    function dlSchalterSetzen(id, an) {
        const feld = document.getElementById(id);
        if (!feld) return false;
        const soll = !!an;
        if (feld.checked !== soll) {
            feld.checked = soll;
            feld.dispatchEvent(new Event('change'));
        }
        const icon = document.querySelector('.starmap-elements-picker .celestial-toggle[data-toggle="' + dlSelektorWert(id) + '"]');
        if (icon) icon.classList.toggle('active__picker', soll);
        return true;
    }

    /* Vorschau-HTML -> Klartext. Gegenstueck zu escapeHtml() + dem <br>-Ersatz in
       updatePreviewFromInputs(): beides laeuft ueber textContent/innerHTML eines <div> und ist
       damit exakt umkehrbar.
       ACHTUNG (Befund): die <br> im gespeicherten Text tragen in echten Bestellungen ATTRIBUTE.
       window.updatePreviewFont() setzt style.fontFamily auf ALLE Kind-Elemente von
       .custom-frame — also auch auf die <br>, die updatePreviewFromInputs() gerade erzeugt hat.
       Gespeichert wird dann z. B. `<br style="font-family: &quot;Great Vibes&quot;, sans-serif;">`.
       Ein Muster ohne Attribute (`<br\s*\/?>`) haette genau diese Zeilenumbrueche verschluckt —
       aus zwei Zeilen waere beim Bearbeiten eine geworden. */
    const DL_BR = /<br\b[^>]*>/gi;

    function dlHtmlZuText(html) {
        const div = document.createElement('div');
        div.innerHTML = String(html == null ? '' : html).replace(DL_BR, '\n');
        return div.textContent;
    }

    /* Dieselbe Formatierung wie syncDateToPreview() bzw. syncLocationToPreview(). Gebraucht,
       um beim Rueckladen zu erkennen, WELCHE der bis zu drei Zeilen unter dem Motiv das Datum
       und welche die Koordinaten sind (gespeichert ist nur die fertige Liste). */
    function dlDatumstextErwartet(datum, zeit) {
        if (!datum) return '';
        const d = new Date(String(datum) + 'T00:00:00');
        if (isNaN(d.getTime())) return '';
        let text = d.toLocaleDateString('de-DE', { year: 'numeric', month: 'long', day: 'numeric' });
        if (zeit) text += ` - ${zeit} Uhr`;
        return text;
    }

    function dlKoordinatentextErwartet(lat, lng) {
        if (!lat || !lng) return '';
        const latDir = lat >= 0 ? 'N' : 'S';
        const lngDir = lng >= 0 ? 'O' : 'W';
        const absLat = Math.abs(lat);
        const absLng = Math.abs(lng);
        const latDeg = Math.floor(absLat);
        const latMin = Math.round((absLat - latDeg) * 60);
        const lngDeg = Math.floor(absLng);
        const lngMin = Math.round((absLng - lngDeg) * 60);
        return `${latDeg}°${String(latMin).padStart(2, '0')}'${latDir} / ${lngDeg}°${String(lngMin).padStart(2, '0')}'${lngDir}`;
    }

    /* Die Zeilen unter dem Motiv (.custom-address) entstehen beim Einsammeln als
       „Datum <br> Ort <br> Koordinaten" — jede der drei kann per Schalter abgewaehlt sein.
       Gespeichert ist nur die LISTE; welche Zeile welches Feld war, steht nirgends.
       Deshalb: alle Kombinationen in fester Reihenfolge durchgehen und die nehmen, die am
       besten zu Datum/Ort/Koordinaten aus der Config passt. Fuer den ROUND-TRIP ist jede
       Zuordnung richtig (die Liste entsteht in derselben Reihenfolge wieder); fuer die
       OBERFLAECHE ist es die, bei der das Datum auch im Datumsfeld steht. */
    function dlZeilenZuordnen(teile, erwartet) {
        const kombis = [[0, 1, 2], [0, 1], [0, 2], [1, 2], [0], [1], [2], []]
            .filter(k => k.length === teile.length);
        let beste = kombis.length ? kombis[0] : [];
        let besteTreffer = -1;
        kombis.forEach(function (kombi) {
            let treffer = 0;
            kombi.forEach(function (slot, i) { if (erwartet[slot] && erwartet[slot] === teile[i]) treffer++; });
            if (treffer > besteTreffer) { besteTreffer = treffer; beste = kombi; }
        });
        const zuordnung = [null, null, null];
        beste.forEach(function (slot, i) { zuordnung[slot] = teile[i]; });
        return zuordnung;
    }

    /* Wartet, bis der Editor wirklich steht: Celestial initialisiert UND der Foto-Schalter
       verdrahtet (initImageUpload laeuft erst 600 ms nach DOMContentLoaded). Ohne das Warten
       laufen Klicks ins Leere und der Kunde saehe den Standard statt seines Motivs. */
    async function dlEditorBereit(deckelMs) {
        const frist = Date.now() + (deckelMs || 12000);
        while (Date.now() < frist) {
            if (celestialInitialized && bildUploadBereit && typeof Celestial !== 'undefined') return true;
            await dlWarte(100);
        }
        return false;
    }

    /* Sammelt GENAU das ein, was beim Einlegen an /api/v1/starmap/render/ geht (und damit das,
       was der Server unter der Job-ID ablegt). Wortgleich aus generateStarmapAndAddToCart()
       herausgeloest — kein Wert geaendert. `order_id` wird hier NICHT neu erzeugt; das macht
       weiterhin der Einlege-Pfad pro Auftrag. */
    window.backendConfigSammeln = function () {
        const config = gatherStarmapConfig();

        // Get selected size info for print dimensions (nur SICHTBARES Panel, Fix 24.08.2026)
        const selectedSize = getVisibleSizeCurrent();
        const paperSize = selectedSize ? selectedSize.getAttribute('data-size') : '30x40cm';

        // Parse paper size to get dimensions
        let widthCm = 30, heightCm = 40;
        try {
            const sizeParts = paperSize.toLowerCase().replace('cm', '').split('x');
            widthCm = parseFloat(sizeParts[0]);
            heightCm = parseFloat(sizeParts[1]);
        } catch (e) {
            console.warn('Could not parse paper size, using defaults');
        }

        // Calculate DPI based on size (same as citymap)
        let dpi = 300;
        const sizeSet = new Set([widthCm, heightCm]);
        if (sizeSet.has(60) && sizeSet.has(80)) dpi = 250;
        else if (sizeSet.has(75) && sizeSet.has(100)) dpi = 220;

        // Calculate pixel dimensions
        const widthInches = widthCm / 2.54;
        const heightInches = heightCm / 2.54;
        const widthPx = Math.floor(widthInches * dpi);
        const heightPx = Math.floor(heightInches * dpi);

        // Build backend config (same structure as citymap)
        return {
            ...config,
            order_id: order_id,
            print: {
                width: widthCm,
                height: heightCm,
                dpi: dpi,
                width_px: widthPx,
                height_px: heightPx,
                orientation: config.orientation || 'portrait'
            }
        };
    };

    /* Setzt den gespeicherten Zustand auf den Editor. Liefert { angewendet, fehlend } —
       fehlt etwas, zeigt der Aufrufer einen Hinweis, loggt die Feldnamen und laesst den Editor
       BEDIENBAR. Nichts wird verschluckt. */
    window.konfigurationAnwenden = async function (config) {
        const angewendet = [];
        const fehlend = [];
        if (!config || typeof config !== 'object') {
            fehlend.push('config');
            return { angewendet, fehlend };
        }
        const hat = feld => Object.prototype.hasOwnProperty.call(config, feld) && config[feld] !== undefined && config[feld] !== null;
        const merke = (name, ok) => { (ok ? angewendet : fehlend).push(name); return ok; };

        await dlEditorBereit();

        /* ---------- 1. Produktart (filtert die Groessen, muss deshalb zuerst) ---------- */
        if (hat('layoutType') && String(config.layoutType) !== '') {
            const produktart = String(config.layoutType);
            let kachel = document.querySelector('.starmap-customizer .tab__switcher ul li a[data-type="' + dlSelektorWert(produktart) + '"]');
            if (!kachel) {
                /* Altbestand: `#starmap-layout-type` startet LEER, gatherStarmapConfig() faellt
                   dann auf 'Poster' zurueck — obwohl die erste Kachel z. B. „Mattes Poster"
                   heisst. Solche Zeilen tragen eine Produktart, zu der es keine Kachel gibt.
                   Dann bleibt die aktive Kachel stehen (sie IST die, mit der bestellt wurde) und
                   nur das versteckte Feld wird gesetzt — damit ist der Zustand exakt der von
                   damals, statt still auf eine andere Produktart zu springen. */
                const feld = document.getElementById('starmap-layout-type');
                if (feld) feld.value = produktart;
                merke('produktart', !!feld);
            } else {
                merke('produktart', dlKachelKlicken(kachel));
            }
        } else {
            fehlend.push('produktart');
        }

        /* ---------- 2. Groesse (nur im sichtbaren Produkttyp-Panel) ---------- */
        if (hat('paperSize') && String(config.paperSize) !== '') {
            const panel = dlSichtbaresFormatPanel();
            const kachel = panel && panel.querySelector('.size__picker a[data-size="' + dlSelektorWert(config.paperSize) + '"]');
            merke('groesse', dlKachelKlicken(kachel));
        } else {
            fehlend.push('groesse');
        }

        /* ---------- 3. Rahmenfarbe ---------- */
        if (hat('frame')) {
            const rahmen = String(config.frame);
            if (rahmen === 'none' || rahmen === '') {
                /* Kein Rahmen gewaehlt: Markierung entfernen, sonst sammelt der Editor beim
                   naechsten Mal die im Markup vorgewaehlte Farbe ein. */
                document.querySelectorAll('.starmap-customizer .image__changer.frame-picker ul li a.current')
                    .forEach(a => a.classList.remove('current'));
                updateFrameImage();
                angewendet.push('rahmenfarbe');
            } else {
                const kachel = document.querySelector('.starmap-customizer .image__changer.frame-picker ul li a[data-frame-color="' + dlSelektorWert(rahmen) + '"]');
                merke('rahmenfarbe', dlKachelKlicken(kachel));
            }
        } else {
            fehlend.push('rahmenfarbe');
        }

        /* ---------- 4. Ausrichtung ---------- */
        if (hat('orientation') && String(config.orientation) !== '') {
            const ausrichtung = String(config.orientation);
            /* Kachel-Picker gibt es in dieser Section nicht (kein .type__switcher im Markup) —
               die Ausrichtung steckt im versteckten Feld und im Rahmenbild. Beides macht
               updateStarmapOrientation(), genau wie der Picker es taete. */
            const flaeche = document.querySelector('.starmap-customizer .canvas__wrapper .media');
            if (flaeche) flaeche.setAttribute('data-resize-type', ausrichtung);
            if (typeof window.updateStarmapOrientation === 'function') {
                window.updateStarmapOrientation(ausrichtung);
                angewendet.push('ausrichtung');
            } else {
                fehlend.push('ausrichtung');
            }
        } else {
            fehlend.push('ausrichtung');
        }

        /* ---------- 5. Hintergrundbild (VOR den Farben: der Schalter schaltet den
                        Grundfarben-Picker ab und setzt Textfarbe/Rand um) ---------- */
        {
            const hintergrund = hat('backgroundImage') ? String(config.backgroundImage) : '';
            const schalter = document.getElementById('enable-background-style');
            if (hintergrund) {
                if (schalter && !schalter.checked) {
                    schalter.checked = true;
                    schalter.dispatchEvent(new Event('change'));
                    await dlWarte(50);
                }
                const kachel = document.querySelector('.starmap-customizer .style-grid li a[data-bg="' + dlSelektorWert(hintergrund) + '"]');
                if (kachel) {
                    dlKachelKlicken(kachel);
                } else {
                    /* Selbst hochgeladener Hintergrund: keine Kachel vorhanden. Die
                       Vorauswahl (der Schalter klickt die erste Kachel an) muss weg, sonst
                       zeigt die Oberflaeche ein fremdes Bild als gewaehlt. */
                    document.querySelectorAll('.starmap-customizer .style-grid li a.current')
                        .forEach(a => a.classList.remove('current'));
                    applyBackgroundImage(hintergrund);
                }
                angewendet.push('hintergrundbild');
            } else if (schalter && schalter.checked) {
                schalter.checked = false;
                schalter.dispatchEvent(new Event('change'));
                await dlWarte(50);
                angewendet.push('hintergrundbild');
            }
        }

        /* ---------- 6. Form (Kreis / Herz / Kompass) — vor den Farben, weil changeShape()
                        das SVG austauscht und die Farben danach neu setzt ---------- */
        if (hat('layout') && String(config.layout) !== '') {
            const kachel = document.querySelector('.starmap-customizer .elem__picker ul li a[data-layout="' + dlSelektorWert(config.layout) + '"]');
            merke('form', dlKachelKlicken(kachel));
        } else {
            fehlend.push('form');
        }

        /* ---------- 7. Farbstil + Grundfarbe (in dieser Reihenfolge: der Stil-Klick nimmt die
                        aktuelle Grundfarbe, der Farb-Klick den aktuellen Stil) ---------- */
        if (hat('mapStyle') && String(config.mapStyle) !== '') {
            const kachel = document.querySelector('.map-style-option[data-style="' + dlSelektorWert(config.mapStyle) + '"]');
            merke('farbstil', dlKachelKlicken(kachel));
        } else {
            fehlend.push('farbstil');
        }

        const grundfarbe = hat('baseColor') ? String(config.baseColor) : (hat('style') ? String(config.style) : '');
        if (grundfarbe) {
            const kachel = document.querySelector('.frame-color-picker .wrap a[data-color="' + dlSelektorWert(grundfarbe) + '"]');
            if (kachel) {
                dlKachelKlicken(kachel);
                angewendet.push('grundfarbe');
            } else {
                /* Frei gewaehlte Farbe: ueber das Farbfeld, genau wie der Kunde. Der Handler
                   ist um 150 ms entprellt — deshalb danach warten. */
                const feld = document.getElementById('custom-color-frame');
                if (feld) {
                    feld.value = grundfarbe;
                    feld.dispatchEvent(new Event('input', { bubbles: true }));
                    await dlWarte(260);
                    angewendet.push('grundfarbe');
                } else {
                    fehlend.push('grundfarbe');
                }
            }
        } else {
            fehlend.push('grundfarbe');
        }

        /* ---------- 8. Textfarbe (nur mit Hintergrundbild frei waehlbar) ---------- */
        if (hat('backgroundImage') && String(config.backgroundImage) !== '' && hat('textColor')) {
            const kachel = document.querySelector('.text-color-picker .wrap a[data-color="' + dlSelektorWert(config.textColor) + '"]');
            merke('textfarbe', dlKachelKlicken(kachel));
        }

        /* ---------- 9. Rand ---------- */
        if (hat('showBorder')) {
            const kachel = document.querySelector('.border__picker .border-options a[data-border="' + (config.showBorder ? 'with' : 'without') + '"]');
            merke('rand', dlKachelKlicken(kachel));
        } else {
            fehlend.push('rand');
        }

        /* ---------- 10. Sternkarten-Optionen ---------- */
        [
            ['sternbilder', 'show-constellations', 'showConstellations'],
            ['sternbildnamen', 'show-constellation-names', 'showConstellationNames'],
            ['sternnamen', 'show-star-names', 'showStarNames'],
            ['gitternetz', 'show-grid', 'showGrid'],
            ['milchstrasse', 'show-milky-way', 'showMilkyWay']
        ].forEach(function (eintrag) {
            const [name, id, feld] = eintrag;
            if (!hat(feld)) { fehlend.push(name); return; }
            merke(name, dlSchalterSetzen(id, config[feld]));
        });

        /* ---------- 11. Datum + Uhrzeit ---------- */
        {
            const datumFeld = document.getElementById('starmap-date-input');
            const zeitFeld = document.getElementById('starmap-time-input');
            if (hat('date') && String(config.date) !== '' && datumFeld) {
                datumFeld.value = String(config.date);
                angewendet.push('datum');
            } else {
                fehlend.push('datum');
            }
            if (hat('time') && String(config.time) !== '' && zeitFeld) {
                zeitFeld.value = String(config.time);
                angewendet.push('uhrzeit');
            } else {
                fehlend.push('uhrzeit');
            }
        }

        /* ---------- 12. Ort + Koordinaten ---------- */
        {
            const ort = hat('location') ? String(config.location) : '';
            const ortFeld = document.getElementById('starmap-location-input');
            if (ortFeld) ortFeld.value = ort;
            merke('ort', !!ortFeld && ort !== '');

            /* `coordinates` ist der String „<lat>, <lng>" aus gatherStarmapConfig(). */
            let lat = currentLat, lng = currentLng, koordOk = false;
            if (hat('coordinates')) {
                const teile = String(config.coordinates).split(',');
                const a = parseFloat(teile[0]);
                const b = parseFloat(teile[1]);
                if (!isNaN(a) && !isNaN(b)) { lat = a; lng = b; koordOk = true; }
            }
            merke('koordinaten', koordOk);
            if (koordOk) {
                updateCelestialLocation(lat, lng);
                updateLocationFields(ort, lat, lng);
            }
            /* Datum/Uhrzeit/Ort zusammen an Celestial — direkt statt ueber die 800-ms-Bremse
               des Eingabe-Handlers. */
            updateCelestialDateTime();
            /* Schreibt textLocation + textCoordinates vor; die echten Zeilen kommen gleich
               aus dem gespeicherten Untertitel. */
            syncLocationToPreview(ort, lat, lng);
            if (hat('date') && String(config.date) !== '') syncDateToPreview(String(config.date));
        }

        /* ---------- 13. Foto (URL uebernehmen, KEIN neuer Upload) ---------- */
        {
            const foto = hat('customImage') ? String(config.customImage) : '';
            const schalter = document.getElementById('enable-custom-image');
            if (foto) {
                uploadedImageUrl = foto;
                uploadedImageData = null;   /* base64 liegt nur beim frischen Zuschnitt vor */
                if (schalter && !schalter.checked) {
                    schalter.checked = true;
                    schalter.dispatchEvent(new Event('change'));
                }
                updateImagePreview(foto);
                updateStarmapBackgroundImage(foto);
                angewendet.push('foto');
            } else {
                uploadedImageUrl = null;
                uploadedImageData = null;
                if (schalter && schalter.checked) {
                    schalter.checked = false;
                    schalter.dispatchEvent(new Event('change'));
                    angewendet.push('foto');
                }
            }
        }

        /* ---------- 14. Texte: Botschaft + die bis zu drei Zeilen darunter ---------- */
        {
            const botschaft = document.getElementById('textMessage');
            if (hat('title') && botschaft) {
                botschaft.value = dlHtmlZuText(config.title);
                botschaft.dispatchEvent(new Event('input', { bubbles: true }));
                angewendet.push('botschaft');
            } else {
                fehlend.push('botschaft');
            }

            if (hat('subtitle')) {
                const roh = String(config.subtitle).trim();
                /* Neue RegExp je Aufruf: DL_BR traegt das g-Flag und damit einen lastIndex,
                   den split() sonst mitschleppen wuerde. */
                let teile = roh === '' ? [] : roh.split(new RegExp(DL_BR.source, 'i')).map(dlHtmlZuText);
                if (teile.length > 3) {
                    /* Mehr als Datum/Ort/Koordinaten kann der Editor nicht abbilden — dann
                       bleibt der Rest liegen, und der Kunde bekommt den Hinweis. */
                    fehlend.push('zusatzzeilen');
                    teile = teile.slice(0, 3);
                }
                const erwartet = [
                    dlDatumstextErwartet(hat('date') ? String(config.date) : '', hat('time') ? String(config.time) : ''),
                    hat('location') ? String(config.location) : '',
                    dlKoordinatentextErwartet(currentLat, currentLng)
                ];
                const zuordnung = dlZeilenZuordnen(teile, erwartet);
                [
                    ['textDate', 'toggle-date', 0],
                    ['textLocation', 'toggle-location', 1],
                    ['textCoordinates', 'toggle-coordinates', 2]
                ].forEach(function (eintrag) {
                    const [feldId, schalterId, slot] = eintrag;
                    const feld = document.getElementById(feldId);
                    const schalter = document.getElementById(schalterId);
                    const an = zuordnung[slot] !== null;
                    /* Wert VOR dem Schalter setzen: ist die Zeile abgewaehlt, sperrt der
                       Schalter-Handler das Feld. */
                    if (feld && an) feld.value = zuordnung[slot];
                    else if (feld && erwartet[slot]) feld.value = erwartet[slot];
                    if (schalter && schalter.checked !== an) {
                        schalter.checked = an;
                        schalter.dispatchEvent(new Event('change'));
                    }
                });
                updatePreviewFromInputs();
                angewendet.push('zusatzzeilen');
            } else {
                fehlend.push('zusatzzeilen');
            }
        }

        /* ---------- 15. Schrift (nach den Texten: updatePreviewFont faerbt auch die
                         Kind-Elemente, die updatePreviewFromInputs neu baut) ---------- */
        if (hat('font') && String(config.font) !== '') {
            /* Es gibt DREI .font__picker-Bloecke (je Tab einen), jeder mit eigener
               `current`-Markierung — der Klick-Handler raeumt nur seinen eigenen auf. */
            const kacheln = document.querySelectorAll('.starmap-customizer .font__picker .font-options-grid li a[data-font="' + dlSelektorWert(config.font) + '"]');
            kacheln.forEach(dlKachelKlicken);
            if (kacheln.length && typeof window.updatePreviewFont === 'function') {
                window.updatePreviewFont(String(config.font));
            }
            merke('schrift', kacheln.length > 0);
        } else if (hat('font')) {
            /* Leerer Wert = Standardschrift. Das versteckte Feld #starmap-font wird erst beim
               Klick auf eine Schrift-Kachel gefuellt; wer nie klickt, legt `font: ""` ein, und
               genau so ging es an den Render-Server. Ein frisch geladener Editor IST dieser
               Zustand — es gibt nichts zu uebernehmen, und es ist kein Fehler (Dominik 12.09.:
               „Einige Angaben konnten nicht uebernommen werden", obwohl alles stimmte). */
            angewendet.push('schrift');
        } else {
            fehlend.push('schrift');
        }

        adjustTextareaFontSize();

        return { angewendet, fehlend };
    };

    /* Startet den Bearbeiten-Modus. Ohne ?edit= ist window.DLCartEdit null und dieser Block tut
       nichts — der Editor verhaelt sich exakt wie vorher. */
    function bearbeitenModusStarten() {
        const bearbeiten = window.DLCartEdit;
        if (!bearbeiten) return;

        /* Einziger fest verdrahteter Text hier: die Meldung fuer eine unvollstaendige oder alte
           Konfiguration (kein Shop-Text mit Theme-Einstellung). Die Meldung fuer eine Zeile aus
           einer FREMDEN Familie steht seit der Final-Fix-Welle (I4) im Helfer — sie ist
           wortgleich mit der der Schmuck-Editoren und soll es bleiben. */
        const HINWEIS_TEILWEISE = 'Einige Angaben konnten nicht übernommen werden.';

        /* PROJ-99 (I1): Knopf SOFORT sperren — vor dem Warten auf `bereit` und erst recht vor
           konfigurationAnwenden(), das auf die Celestial-Zeichnung wartet. Bis dahin zeigt der
           Editor den Default-Himmel; ein Klick darauf legte genau den in den Warenkorb und
           abschliessen() loeschte danach das Kundenmotiv. Freigegeben wird unten
           (knopfAnpassen nach dem Anwenden) oder vom Helfer (knopfFreigeben bei Abbruch). */
        bearbeiten.knopfSperren(document.querySelector('.starmap-customizer .cart-btn'));

        bearbeiten.bereit.then(async function (config) {
            /* Der Helfer hat den Modus schon abgeschaltet (Zeile weg, Config nicht ladbar) und
               seinen Hinweis gezeigt — hier bleibt nichts zu tun. */
            if (!config) return;

            if (bearbeiten.familie !== 'starmap') {
                /* Der Bearbeiten-Link zeigt auf diese Seite, die Zeile gehoert aber zu einer
                   anderen Editor-Familie. Lieber gar nicht anwenden als ein fremdes Motiv
                   ueberschreiben. */
                console.warn('[PROJ-99] Warenkorbzeile gehoert zur Familie "' + bearbeiten.familie + '", nicht zu starmap.');
                bearbeiten.hinweis(bearbeiten.HINWEIS_ANDERES_PRODUKT);
                /* I1: erst den Knopf zurueckgeben, dann den Modus abschalten — danach ist der
                   Helfer ueber window.DLCartEdit nicht mehr erreichbar. */
                bearbeiten.knopfFreigeben();
                window.DLCartEdit = null;
                return;
            }

            try {
                const ausConfig = await window.konfigurationAnwenden(config);
                if (ausConfig.fehlend.length) {
                    console.warn('[PROJ-99] Nicht uebernommen:', ausConfig.fehlend.join(', '));
                    bearbeiten.hinweis(HINWEIS_TEILWEISE);
                }
                bearbeiten.knopfAnpassen(document.querySelector('.starmap-customizer .cart-btn'));
                window.__dlBearbeitenErgebnis = { ausConfig: ausConfig };
            } catch (e) {
                /* Ein Fehler beim Anwenden darf den Editor nicht lahmlegen — er bleibt
                   bedienbar, nur eben mit dem, was schon gesetzt wurde. */
                console.error('[PROJ-99] Bearbeiten-Modus konnte nicht vollstaendig hergestellt werden:', e);
                bearbeiten.hinweis(HINWEIS_TEILWEISE);
                bearbeiten.knopfAnpassen(document.querySelector('.starmap-customizer .cart-btn'));
                window.__dlBearbeitenErgebnis = { ausConfig: { angewendet: [], fehlend: ['ausnahme'] } };
            }
        });
    }

    function addToCartViaFetch(config) {
        const variantInput = document.querySelector('.starmap-customizer input[name="id"]');
        if (!variantInput) {
            console.error('No variant ID found');
            return;
        }

        // Build image URLs using job ID (same pattern as citymap)
        const imageUrl = `${BACKEND_API_URL}/data/${config.order_id}/`;

        // Cart-Vorschau (PROJ-72, 08.08.): persistente Server-Miniatur des
        // fertigen Posters (600px-Downscale) statt Modal-Variable/Redirect
        // aufs riesige Print-PNG. Sofort-Anzeige kommt vom Session-
        // Schnappschuss (kaSofortVorschau weiter oben im Add-Flow).
        // Die Miniatur liegt im nginx-Bilderordner /media/ des Servers, NICHT unter
        // dem API-Prefix: BACKEND_API_URL endet auf /api/v1/starmap, das ergab bis
        // 13.09.2026 eine Adresse, die immer 404 lieferte (Befund Dominik).
        const previewImageUrl = `${BACKEND_API_URL.replace(/\/api\/v1\/starmap$/, '')}/media/blanket_renders/${config.order_id}_cartpreview.jpg`;

        const formData = {
            items: [{
                id: variantInput.value,
                quantity: 1,
                properties: {
                    // All properties prefixed with _ to hide from cart display
                    '_job_id': config.order_id,
                    '_print_image_url': imageUrl,
                    '_preview_image_url': previewImageUrl,
                    '_OrderID': config.order_id,
                    '_Date': config.date,
                    '_Time': config.time,
                    '_Location': config.location,
                    '_Coordinates': config.coordinates,
                    '_Title_Large': config.title,
                    '_Title_Small': config.subtitle,
                    '_Style': config.style,
                    '_Map_Style': config.mapStyle,  // Preset: filled, outline, inner-filled, ring
                    '_Show_Constellations': config.showConstellations ? 'Yes' : 'No',
                    '_Show_Star_Names': config.showConstellationNames ? 'Yes' : 'No',
                    '_Show_Grid': config.showGrid ? 'Yes' : 'No',
                    '_Layout_Shape': config.layout,
                    '_Layout_Type': config.layoutType,
                    '_Font_Family': config.font,
                    '_Frame': config.frame,
                    '_Orientation': config.orientation,
                    '_Paper_Size': config.paperSize,
                    '_Custom_Colors': config.starMapColor ? `Map: ${config.starMapColor}, Frame: ${config.frameBackgroundColor}` : '',
                    '_Custom_Image': config.customImage || '',
                    /* PROJ-99: Ziel des „Bearbeiten"-Links in der Warenkorbzeile. NUR der Pfad,
                       ohne Query — der Bearbeiten-Modus haengt sein eigenes ?edit= an, und die
                       Preset-/Kampagnen-Parameter der Erstbestellung wuerden beim Wiederoeffnen
                       den geladenen Zustand ueberschreiben. */
                    '_editor_url': window.location.pathname,
                    '_Starmap_Config_JSON': JSON.stringify(config)
                }
            }]
        };

        // Add frame color if framed poster is selected
        const frameColorEl = document.querySelector('.starmap-customizer .frame-picker ul li a.current');
        const selectedFrameColor = frameColorEl ? (frameColorEl.getAttribute('data-frame-color') || '') : '';
        const selectedProductType = document.querySelector('.starmap-customizer .tab__switcher ul li a.current')?.textContent?.trim() || '';
        if (selectedFrameColor && selectedProductType.includes('Holzrahmen')) {
            formData.items[0].properties['_Frame Color'] = selectedFrameColor;
        }

        // Sofort-Vorschau fuer den Warenkorb (PROJ-72): Schnappschuss der
        // sichtbaren Poster-Vorschau (single-map-view) in sessionStorage —
        // der Cart-Drawer zeigt das Motiv sofort, ohne auf den Server-Render
        // zu warten. Helper ist fail-soft (2,5s-Notbremse), der Kauf wird
        // nie blockiert.
        const stageEl = document.querySelector('.starmap-customizer .canvas__wrapper .inn.single-map-view');
        const vorschauFertig = window.kaSofortVorschau
            ? window.kaSofortVorschau(stageEl, config.order_id)
            : Promise.resolve();

        vorschauFertig.then(() => fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        }))
        .then(response => {
            return response.json().then(data => {
                if (!response.ok) {
                    throw new Error(data.description || data.message || 'Artikel konnte nicht zum Warenkorb hinzugefügt werden');
                }
                return data;
            });
        })
        .then(data => {
            console.log('Added to cart:', data);

            // GTM dataLayer AddToCart Event
            if (window.DLTrack && window.DLTrack.addToCart) {
                window.DLTrack.addToCart(data);
            }

            /* Dem Theme den VOLLEN Warenkorb melden (assets/cart-melden.js): die Antwort von
			   add.js allein liess Prestige in cart:change auflaufen (fehlende sections/items).
			   Ohne den Helfer bleibt es beim alten cart:refresh. */
            if (window.DLCartMelden) {
            	window.DLCartMelden.nachAdd();
            } else {
            	document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            }

            /* PROJ-99 Bearbeiten-Modus: die NEUE Zeile liegt jetzt im Warenkorb — erst danach
               darf die alte weg (sonst waere der Warenkorb im Fehlerfall leer). abschliessen()
               entfernt sie, beendet den Modus (Knopf wieder „In den Warenkorb", Adresse ohne
               edit) und oeffnet den Drawer — nie die grosse Warenkorb-Seite (Dominik 12.09.). */
            if (window.DLCartEdit && window.DLCartEdit.familie === 'starmap') {
                const uebernahmeKnopf = document.querySelector('.starmap-customizer .cart-btn');
                if (uebernahmeKnopf) uebernahmeKnopf.textContent = 'Änderung wird übernommen...';
                /* PROJ-99 (C1): Die Antwort von /cart/add.js geht mit — nennt sie den Schluessel
                   der ALTEN Zeile, hat Shopify zusammengefuehrt und die Zeile darf nur gekuerzt,
                   nicht entfernt werden. Bei der Sternkarte passiert das nie (jede neue Zeile
                   traegt eine frische Job-ID), der Helfer bekommt das Signal trotzdem: er ist
                   fuer alle zwoelf Editoren derselbe. */
                return window.DLCartEdit.abschliessen(data).then(uebernommen => {
                    if (!uebernommen || !uebernahmeKnopf) return uebernommen;
                    /* Kurze Bestaetigung wie beim normalen Einlegen, dann der Originaltext,
                       den der Helfer am Knopf hinterlegt hat. */
                    const originaltextNachBearbeiten = uebernahmeKnopf.dataset.dlOriginaltext || 'In den Warenkorb';
                    uebernahmeKnopf.textContent = '✓ Änderung übernommen!';
                    setTimeout(() => {
                        uebernahmeKnopf.textContent = originaltextNachBearbeiten;
                        uebernahmeKnopf.style.pointerEvents = 'auto';
                    }, 2000);
                    return uebernommen;
                });
            }

            // Open cart drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.show === 'function') {
                cartDrawer.show();
            } else {
                window.location.href = (window.Shopify.routes.root || '/') + 'cart';
            }

            // Restore button
            const addToCartBtn = document.querySelector('.starmap-customizer .bottom__controls .btn > a');
            if (addToCartBtn) {
                addToCartBtn.innerHTML = '✓ Zum Warenkorb hinzugefügt!';
                addToCartBtn.style.pointerEvents = 'auto';
            }
        })
        .catch(error => {
            console.error('Error adding to cart:', error);
            showToast('Fehler: ' + error.message);
            /* PROJ-99: der echte Knopf wurde im Bearbeiten-Modus gesperrt (siehe
               generateStarmapAndAddToCart) — sonst bliebe die Seite eingefroren. */
            const knopf = document.querySelector('.starmap-customizer .cart-btn');
            if (knopf) knopf.style.pointerEvents = 'auto';
        });
    }

    // =============================================
    // IMAGE UPLOAD FUNCTIONALITY
    // =============================================

    // Cache der letzten hochgeladenen base64-Daten für "Neu zuschneiden"
    let lastUploadedImageData = null;

    // Initialize image upload handlers
    function initImageUpload() {
        const enableToggle = document.getElementById('enable-custom-image');
        const uploadArea = document.getElementById('image-upload-area');
        const imagePreview = document.getElementById('starmap-image-preview');
        const changeBtn = document.getElementById('change-starmap-image');
        const removeBtn = document.getElementById('remove-starmap-image');
        const recropBtn = document.getElementById('starmap-photo-recrop-btn');
        const fileInput = document.getElementById('starmap-photo-file-input');
        const closeCropBtn = document.getElementById('close-crop-popup');
        const cancelCropBtn = document.getElementById('cancel-crop');
        const applyCropBtn = document.getElementById('apply-crop');

        // Toggle switch handler - show/hide upload box and placeholder
        if (enableToggle) {
            enableToggle.addEventListener('change', function() {
                const sidebarUploadBox = document.getElementById('sidebar-upload-box');
                const placeholder = document.getElementById('starmap-photo-placeholder');
                const imagePreviewEl = document.getElementById('starmap-image-preview');
                const imageActionsEl = document.querySelector('.image-actions');

                if (this.checked) {
                    // Show upload area container first
                    const uploadArea = document.getElementById('image-upload-area');
                    if (uploadArea) uploadArea.style.display = 'block';
                    // V9.96.26a: Mama-Pattern — Upload-Button + Hint einblenden
                    // wenn noch kein Bild hochgeladen. 'flex' für .photo-upload-button.
                    const uploadHint = document.querySelector('.starmap-customizer .photo-upload-hint');
                    if (!uploadedImageUrl) {
                        if (sidebarUploadBox) sidebarUploadBox.style.display = 'flex';
                        if (uploadHint) uploadHint.style.display = 'block';
                        const customizer = document.querySelector('.starmap-customizer');
                        const bgImg = document.getElementById('bg-img-new');
                        if (bgImg && customizer && customizer.dataset.photoMockupUrl) {
                            bgImg.src = customizer.dataset.photoMockupUrl;
                            bgImg.style.display = 'block';
                        }
                    }
                } else {
                    // Hide everything
                    const uploadArea = document.getElementById('image-upload-area');
                    const uploadHint = document.querySelector('.starmap-customizer .photo-upload-hint');
                    if (uploadArea) uploadArea.style.display = 'none';
                    if (sidebarUploadBox) sidebarUploadBox.style.display = 'none';
                    if (uploadHint) uploadHint.style.display = 'none';
                    if (placeholder) placeholder.style.display = 'none';
                    // bg-img-new auch verstecken (zeigt sonst Mockup weiter
                    // an obwohl Toggle off ist).
                    const bgImg = document.getElementById('bg-img-new');
                    if (bgImg) {
                        bgImg.src = '';
                        bgImg.style.display = 'none';
                    }
                    if (uploadedImageUrl) {
                        removeUploadedImage();
                    }
                }
            });
        }

        // V9.96.26a: Mama-Pattern — Label#sidebar-upload-box öffnet hidden file-input
        // nativ via Click. KEIN click-Listener mehr auf sidebar-upload-box (würde
        // sonst doppelt File-Picker triggern). Change-Event auf dem hidden input.
        if (fileInput) {
            fileInput.addEventListener('change', handleImageSelect);
        }

        // Click on canvas placeholder to trigger upload
        const photoPlaceholder = document.getElementById('starmap-photo-placeholder');
        if (photoPlaceholder) {
            photoPlaceholder.addEventListener('click', function() {
                triggerImageUpload();
            });
        }

        if (imagePreview) {
            imagePreview.addEventListener('click', function() {
                if (!uploadedImageUrl) {
                    triggerImageUpload();
                }
            });
        }

        if (changeBtn) {
            changeBtn.addEventListener('click', triggerImageUpload);
        }

        if (removeBtn) {
            removeBtn.addEventListener('click', removeUploadedImage);
        }

        // V9.96.26a: Neu zuschneiden — öffnet Cropper mit dem zuletzt hochgeladenen Bild
        if (recropBtn) {
            recropBtn.addEventListener('click', function() {
                if (lastUploadedImageData) {
                    openCropPopup(lastUploadedImageData);
                }
            });
        }

        if (closeCropBtn) {
            closeCropBtn.addEventListener('click', closeCropPopup);
        }

        if (cancelCropBtn) {
            cancelCropBtn.addEventListener('click', closeCropPopup);
        }

        if (applyCropBtn) {
            applyCropBtn.addEventListener('click', applyCrop);
        }

        // Close popup on overlay click
        const cropPopup = document.getElementById('starmap-crop-popup');
        if (cropPopup) {
            cropPopup.addEventListener('click', function(e) {
                if (e.target === cropPopup) {
                    closeCropPopup();
                }
            });
        }

        /* PROJ-99: ab hier haengt am Foto-Schalter ein Handler — der Bearbeiten-Modus wartet
           auf diese Marke, bevor er ein gespeichertes Foto zurueckholt. */
        bildUploadBereit = true;
    }

    function triggerImageUpload() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/jpeg,image/jpg,image/png';
        input.style.display = 'none';
        input.addEventListener('change', function(e) {
            if (e.target.files && e.target.files.length > 0) {
                handleImageSelect(e);
            } else {
                // User cancelled - turn off toggle if no image was already uploaded
                if (!uploadedImageUrl) {
                    const enableToggle = document.getElementById('enable-custom-image');
                    if (enableToggle) enableToggle.checked = false;
                }
            }
        });
        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    }

    function handleImageSelect(event) {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
        if (!validTypes.includes(file.type.toLowerCase())) {
            showToast('Ungültiges Dateiformat. Bitte wähle ein JPG, JPEG oder PNG Bild.');
            return;
        }

        // Validate file size (50MB limit)
        if (file.size > 50 * 1024 * 1024) {
            showToast('Bitte wähle ein Bild unter 50MB.');
            return;
        }

        const reader = new FileReader();
        reader.onload = function(e) {
            // V9.96.26a: cache base64 für "Neu zuschneiden"
            lastUploadedImageData = e.target.result;
            openCropPopup(e.target.result);
        };
        reader.onerror = function() {
            showToast('Fehler beim Lesen der Datei. Bitte versuche es erneut.');
        };
        reader.readAsDataURL(file);
    }

    function openCropPopup(imageData) {
        const popup = document.getElementById('starmap-crop-popup');
        const cropperImage = document.getElementById('starmap-cropper-image');

        if (!popup || !cropperImage) return;

        cropperImage.src = imageData;
        popup.style.display = 'flex';

        // Initialize cropper after image loads
        setTimeout(function() {
            if (window.Cropper) {
                // Destroy existing cropper
                if (starmapCropper) {
                    starmapCropper.destroy();
                    starmapCropper = null;
                }

                // Mobile-friendly sizing
                var isMobile = window.innerWidth <= 768;
                var minCropSize = isMobile ? 100 : 150;

                starmapCropper = new window.Cropper(cropperImage, {
                    aspectRatio: 1, // Square aspect ratio for circle crop
                    viewMode: 1,    // Restrict crop box to not exceed canvas boundaries
                    dragMode: 'move', // Move the image, not the crop box
                    modal: true,    // Show dark overlay outside crop area
                    background: true, // Show grid background
                    guides: false,   // Hide grid guides for cleaner UI
                    autoCropArea: 0.8, // Crop area size
                    center: true,   // Center the crop area
                    highlight: false, // No highlight for cleaner UI
                    cropBoxMovable: true, // Allow moving the crop box
                    cropBoxResizable: true, // Allow resizing the crop box
                    toggleDragModeOnDblclick: false, // No mode toggling
                    movable: true,  // Allow moving the image underneath
                    zoomable: true, // Enable zoom
                    zoomOnTouch: true, // Enable pinch-to-zoom on mobile
                    zoomOnWheel: true, // Enable mouse wheel zoom
                    wheelZoomRatio: 0.1, // Zoom ratio for mouse wheel
                    scalable: true, // Allow image scaling
                    rotatable: true, // Enable rotation
                    minCropBoxWidth: minCropSize,  // Minimum crop box size
                    minCropBoxHeight: minCropSize,
                    ready: function() {
                        // Set fixed crop box in center - responsive sizing
                        setTimeout(function() {
                            const containerData = starmapCropper.getContainerData();
                            const maxSize = Math.min(containerData.width, containerData.height) * 0.7;
                            const cropBoxSize = Math.min(isMobile ? 120 : 150, maxSize);
                            starmapCropper.setCropBoxData({
                                width: cropBoxSize,
                                height: cropBoxSize,
                                left: (containerData.width - cropBoxSize) / 2,
                                top: (containerData.height - cropBoxSize) / 2
                            });
                        }, 50);
                    }
                });
            }
        }, 100);
    }

    function closeCropPopup() {
        const popup = document.getElementById('starmap-crop-popup');
        if (popup) {
            popup.style.display = 'none';
        }

        if (starmapCropper) {
            starmapCropper.destroy();
            starmapCropper = null;
        }

        // Reset progress
        const progressDiv = document.getElementById('crop-progress');
        if (progressDiv) {
            progressDiv.style.display = 'none';
        }
    }

    async function applyCrop() {
        if (!starmapCropper) return;

        const progressDiv = document.getElementById('crop-progress');
        const progressBar = document.getElementById('crop-progress-bar');
        const progressText = document.getElementById('crop-progress-text');

        // Show progress
        if (progressDiv) progressDiv.style.display = 'block';
        if (progressBar) progressBar.style.width = '10%';

        try {
            // High-quality crop calculation like citymap
            const cropBoxData = starmapCropper.getCropBoxData();
            const imageData = starmapCropper.getImageData();

            // Calculate scale between displayed image and actual image
            const scaleX = imageData.naturalWidth / imageData.width;
            const scaleY = imageData.naturalHeight / imageData.height;

            // Calculate actual cropped area size
            const croppedWidth = cropBoxData.width * scaleX;
            const croppedHeight = cropBoxData.height * scaleY;

            // For square crop, use the smaller dimension
            const actualSquareSize = Math.min(croppedWidth, croppedHeight);

            // Use optimal size up to 2048px for high quality
            const optimalSize = Math.min(Math.round(actualSquareSize), 2048);

            console.log('Crop quality:', {
                naturalSize: `${imageData.naturalWidth}x${imageData.naturalHeight}`,
                croppedArea: `${Math.round(croppedWidth)}x${Math.round(croppedHeight)}`,
                outputSize: `${optimalSize}x${optimalSize}`
            });

            const canvas = starmapCropper.getCroppedCanvas({
                width: optimalSize,
                height: optimalSize,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high'
            });

            if (!canvas) {
                throw new Error('Zugeschnittenes Bild konnte nicht erstellt werden');
            }

            if (progressBar) progressBar.style.width = '30%';

            // Convert to blob
            const blob = await new Promise((resolve, reject) => {
                canvas.toBlob(
                    (b) => b ? resolve(b) : reject(new Error('Bild konnte nicht konvertiert werden')),
                    'image/jpeg',
                    0.9
                );
            });

            if (progressBar) progressBar.style.width = '50%';
            if (progressText) progressText.textContent = 'Wird hochgeladen...';

            // Upload to S3
            const s3Url = await uploadImageToS3(blob, function(progress) {
                if (progressBar) progressBar.style.width = (50 + progress * 0.4) + '%';
            });

            if (progressBar) progressBar.style.width = '95%';
            if (progressText) progressText.textContent = 'Wird abgeschlossen...';

            // Save URL and update preview
            uploadedImageUrl = s3Url;
            uploadedImageData = canvas.toDataURL('image/jpeg', 0.9);

            updateImagePreview(s3Url);
            updateStarmapBackgroundImage(s3Url);

            if (progressBar) progressBar.style.width = '100%';

            // Close popup after short delay
            setTimeout(closeCropPopup, 500);

        } catch (error) {
            console.error('Error applying crop:', error);
            showToast('Fehler bei der Bildverarbeitung. Bitte versuche es erneut.');
            if (progressDiv) progressDiv.style.display = 'none';
        }
    }

    async function uploadImageToS3(blob, progressCallback) {
        try {
            // Step 1: Get presigned URL
            const presignedResponse = await fetch('https://tiles.distantlines.de/api/v1/upload/presigned-url/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    file_name: 'starmap_image_' + Date.now() + '.jpg',
                    content_type: 'image/jpeg'
                })
            });

            if (!presignedResponse.ok) {
                throw new Error('Upload-URL konnte nicht abgerufen werden');
            }

            const presignedData = await presignedResponse.json();
            console.log('Presigned URL response:', presignedData);

            if (!presignedData.success) {
                throw new Error('Presigned URL konnte nicht abgerufen werden');
            }

            // Step 2: Upload to S3
            const formData = new FormData();
            Object.keys(presignedData.fields).forEach(key => {
                formData.append(key, presignedData.fields[key]);
            });
            formData.append('file', blob, 'starmap_image.jpg');

            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', presignedData.uploadUrl, true);

                xhr.upload.onprogress = function(e) {
                    if (e.lengthComputable && progressCallback) {
                        progressCallback(e.loaded / e.total);
                    }
                };

                xhr.onload = function() {
                    if (xhr.status >= 200 && xhr.status < 300) {
                        // Use the publicUrl from the response
                        resolve(presignedData.publicUrl);
                    } else {
                        reject(new Error('Upload fehlgeschlagen mit Status: ' + xhr.status));
                    }
                };

                xhr.onerror = function() {
                    reject(new Error('Upload fehlgeschlagen'));
                };

                xhr.send(formData);
            });

        } catch (error) {
            console.error('S3 upload error:', error);
            throw error;
        }
    }

    function updateImagePreview(imageUrl) {
        const uploadArea = document.getElementById('image-upload-area');
        const previewBox = document.getElementById('starmap-image-preview');
        // V9.96.26a: .image-actions ersetzt durch .photo-change-row mit .visible toggle.
        const changeRow = document.getElementById('starmap-photo-change-row');
        const sidebarUploadBox = document.getElementById('sidebar-upload-box');
        const uploadHint = document.querySelector('.starmap-customizer .photo-upload-hint');
        const placeholder = document.getElementById('starmap-photo-placeholder');

        // Hide upload button + hint + placeholder when real image is shown.
        if (sidebarUploadBox) sidebarUploadBox.style.display = 'none';
        if (uploadHint) uploadHint.style.display = 'none';
        if (placeholder) placeholder.style.display = 'none';

        // Show the upload area with preview
        if (uploadArea) {
            uploadArea.style.display = 'block';
        }

        if (previewBox) {
            previewBox.innerHTML = `<img src="${imageUrl}" alt="Uploaded image" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
            previewBox.style.cursor = 'default';
            previewBox.style.display = 'block';
        }

        if (changeRow) {
            changeRow.classList.add('visible');
        }
    }

    function updateStarmapBackgroundImage(imageUrl) {
        // Update the #bg-img-new element like shopify-starmap-work does
        const bgImg = document.getElementById('bg-img-new');
        if (bgImg) {
            bgImg.src = imageUrl;
            bgImg.style.display = 'block';
        }

        // Add margin to text area to make room for image
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.classList.add('mt-6v');
        }

        // Trigger spacing adjustment to resize fonts for image presence
        triggerSpacingAdjustment();
    }

    // Trigger the spacing adjustment in starmap.js
    function triggerSpacingAdjustment() {
        // Dispatch a custom event that starmap.js can listen for
        window.dispatchEvent(new CustomEvent('starmapImageChanged'));
    }

    // Disable frame color picker and border controls when background image is added
    function disableFrameAndBorderControls() {
        // Select black color for frame
        const blackFrameLink = document.querySelector('.frame-color-picker .wrap a[data-color="#1a1a1a"]');
        if (blackFrameLink) {
            // Remove current from all frame colors
            document.querySelectorAll('.frame-color-picker .wrap a').forEach(function(a) {
                a.classList.remove('current');
            });
            blackFrameLink.classList.add('current');
            blackFrameLink.click(); // Apply the black color
        }

        // Hide/disable frame color picker section (the one containing .frame-color-picker)
        const frameColorPicker = document.querySelector('.frame-color-picker');
        const frameColorSection = frameColorPicker ? frameColorPicker.closest('.elem__picker') : null;
        if (frameColorSection) {
            frameColorSection.style.opacity = '0.5';
            frameColorSection.style.pointerEvents = 'none';
            // Add disabled message
            if (!frameColorSection.querySelector('.disabled-msg')) {
                const msg = document.createElement('p');
                msg.className = 'disabled-msg';
                msg.style.cssText = 'font-size: 11px; color: #888; margin: 8px 0 0; font-style: italic;';
                msg.textContent = 'Nicht verfügbar mit Hintergrundbildern';
                frameColorSection.appendChild(msg);
            }
        }

        // Turn off border and disable it
        const borderToggle = document.getElementById('enable-frame-border');
        if (borderToggle) {
            borderToggle.checked = false;
            borderToggle.dispatchEvent(new Event('change')); // Trigger change to turn off border
            borderToggle.disabled = true;
        }

        // Disable border section
        const borderSection = borderToggle ? borderToggle.closest('.elem__picker') : null;
        if (borderSection) {
            borderSection.style.opacity = '0.5';
            borderSection.style.pointerEvents = 'none';
            // Add disabled message
            if (!borderSection.querySelector('.disabled-msg')) {
                const msg = document.createElement('p');
                msg.className = 'disabled-msg';
                msg.style.cssText = 'font-size: 11px; color: #888; margin: 8px 0 0; font-style: italic;';
                msg.textContent = 'Nicht verfügbar mit Hintergrundbildern';
                borderSection.appendChild(msg);
            }
        }
    }

    // Enable frame color picker and border controls when background image is removed
    function enableFrameAndBorderControls() {
        // Enable frame color picker section (the one containing .frame-color-picker)
        const frameColorPicker = document.querySelector('.frame-color-picker');
        const frameColorSection = frameColorPicker ? frameColorPicker.closest('.elem__picker') : null;
        if (frameColorSection) {
            frameColorSection.style.opacity = '1';
            frameColorSection.style.pointerEvents = 'auto';
            // Remove disabled message
            const msg = frameColorSection.querySelector('.disabled-msg');
            if (msg) msg.remove();
        }

        // Enable border toggle
        const borderToggle = document.getElementById('enable-frame-border');
        if (borderToggle) {
            borderToggle.disabled = false;
        }

        // Enable border section
        const borderSection = borderToggle ? borderToggle.closest('.elem__picker') : null;
        if (borderSection) {
            borderSection.style.opacity = '1';
            borderSection.style.pointerEvents = 'auto';
            // Remove disabled message
            const msg = borderSection.querySelector('.disabled-msg');
            if (msg) msg.remove();
        }
    }

    function removeUploadedImage() {
        uploadedImageUrl = null;
        uploadedImageData = null;
        lastUploadedImageData = null;  // V9.96.26a: clear recrop cache

        // Get elements
        const uploadArea = document.getElementById('image-upload-area');
        const previewBox = document.getElementById('starmap-image-preview');
        // V9.96.26a: .image-actions ersetzt durch .photo-change-row
        const changeRow = document.getElementById('starmap-photo-change-row');
        const enableToggle = document.getElementById('enable-custom-image');
        const sidebarUploadBox = document.getElementById('sidebar-upload-box');
        const uploadHint = document.querySelector('.starmap-customizer .photo-upload-hint');
        const placeholder = document.getElementById('starmap-photo-placeholder');

        // Hide the image preview and actions
        if (previewBox) {
            previewBox.innerHTML = '';
            previewBox.style.display = 'none';
        }

        if (changeRow) {
            changeRow.classList.remove('visible');
        }

        // Show upload button + hint again if toggle is still checked, plus Mockup
        // zurueck in #bg-img-new (statt leeren).
        const bgImg = document.getElementById('bg-img-new');
        if (enableToggle && enableToggle.checked) {
            if (sidebarUploadBox) sidebarUploadBox.style.display = 'flex';
            if (uploadHint) uploadHint.style.display = 'block';
            const customizer = document.querySelector('.starmap-customizer');
            if (bgImg && customizer && customizer.dataset.photoMockupUrl) {
                bgImg.src = customizer.dataset.photoMockupUrl;
                bgImg.style.display = 'block';
            }
        } else {
            // Toggle off — bg-img-new komplett verstecken.
            if (bgImg) {
                bgImg.src = '';
                bgImg.style.display = 'none';
            }
        }

        // Remove margin from text area
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.classList.remove('mt-6v');
        }

        // Trigger spacing adjustment to resize fonts back
        triggerSpacingAdjustment();
    }

    // Global cropper control functions
    window.zoomStarmapCropper = function(delta) {
        if (starmapCropper) {
            starmapCropper.zoom(delta);
        }
    };

    window.rotateStarmapCropper = function(degrees) {
        if (starmapCropper) {
            starmapCropper.rotate(degrees);
        }
    };

    window.resetStarmapCropper = function() {
        if (starmapCropper) {
            starmapCropper.reset();
            setTimeout(function() {
                if (starmapCropper) {
                    const containerData = starmapCropper.getContainerData();
                    const size = Math.min(containerData.width, containerData.height) * 0.85;
                    starmapCropper.setCropBoxData({
                        left: (containerData.width - size) / 2,
                        top: (containerData.height - size) / 2,
                        width: size,
                        height: size
                    });
                }
            }, 100);
        }
    };

    // Initialize image upload when DOM is ready
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initImageUpload, 600);
    });

    function applyBackground(bgUrl) {
        const customFrame = document.querySelector('.custom-frame.bg-new');
        if (customFrame) {
            customFrame.style.backgroundImage = 'url("' + bgUrl + '?width=150")';
            customFrame.style.backgroundSize = 'cover';
            customFrame.style.backgroundPosition = 'center';
        }
    }

    // Apply background image from style picker
    function applyBackgroundImage(bgUrl) {
        const customFrame = document.querySelector('.custom-frame.bg-new');
        if (customFrame) {
            customFrame.style.backgroundImage = 'url("' + bgUrl + '?width=450")';
            customFrame.style.backgroundSize = 'cover';
            customFrame.style.backgroundPosition = 'center';
        }

        // Save to hidden field for backend
        let hidden = document.getElementById('starmap-background-image');
        if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.id = 'starmap-background-image';
            document.body.appendChild(hidden);
        }
        hidden.value = bgUrl;

        // Get selected text color from picker, default to white
        const textColorLink = document.querySelector('.text-color-picker .wrap a.current');
        const textColor = textColorLink ? textColorLink.getAttribute('data-color') : '#ffffff';

        // Update frame text color
        if (customFrame) {
            customFrame.style.color = textColor;
        }

        // Update preview title and subtitle
        const previewTitle = document.getElementById('preview-title');
        const previewSubtitle = document.getElementById('preview-subtitle');
        if (previewTitle) {
            previewTitle.style.setProperty('color', textColor, 'important');
        }
        if (previewSubtitle) {
            previewSubtitle.style.setProperty('color', textColor, 'important');
        }

        // Update custom-textarea text
        const customTextarea = document.querySelector('.custom-textarea');
        if (customTextarea) {
            customTextarea.style.setProperty('color', textColor, 'important');
            customTextarea.querySelectorAll('*').forEach(el => {
                el.style.setProperty('color', textColor, 'important');
            });
        }

        // Update border/stroke colors - follows text color
        const borElements = document.querySelectorAll('.bor');
        borElements.forEach(el => {
            el.style.setProperty('fill', textColor, 'important');
            el.style.setProperty('stroke', textColor, 'important');
        });

        // Update stroke elements
        const strokeElements = document.querySelectorAll('.strokeCouple');
        strokeElements.forEach(el => {
            el.style.setProperty('stroke', textColor, 'important');
        });

        // Update compass elements
        const compassBorder = document.querySelector('.compass-border');
        if (compassBorder) {
            compassBorder.setAttribute('stroke', textColor);
            compassBorder.style.setProperty('stroke', textColor, 'important');
        }

        // Update all SVG stroke elements in custom_iframe
        const customIframe = document.querySelector('.custom_iframe');
        if (customIframe) {
            // Update .bor class elements with important
            customIframe.querySelectorAll('.bor').forEach(el => {
                el.style.setProperty('fill', textColor, 'important');
                el.style.setProperty('stroke', textColor, 'important');
            });
            customIframe.querySelectorAll('[stroke]').forEach(el => {
                if (el.getAttribute('stroke') !== 'none') {
                    el.setAttribute('stroke', textColor);
                    el.style.setProperty('stroke', textColor, 'important');
                }
            });
            customIframe.querySelectorAll('circle, path').forEach(el => {
                if (el.classList.contains('bor') || el.getAttribute('stroke')) {
                    el.style.setProperty('stroke', textColor, 'important');
                }
            });
        }

        // Note: Background image should NOT affect star map colors
        // Star map colors are controlled by Star Map Color picker

        // Update frame border if enabled
        updateFrameBorder();

        // Hide custom style color picker
        const customStylePanel = document.querySelector('.starmap-customizer .custom__style');
        if (customStylePanel) {
            customStylePanel.style.display = 'none';
        }
    }

    // Remove background image
    function removeBackground() {
        const customFrame = document.querySelector('.custom-frame.bg-new');
        if (customFrame) {
            customFrame.style.backgroundImage = '';
            customFrame.style.backgroundSize = '';
            customFrame.style.backgroundPosition = '';
        }
        
        // Clear hidden field
        const hidden = document.getElementById('starmap-background-image');
        if (hidden) hidden.value = '';
    }

    // Trigger background image upload for custom style
    function triggerBackgroundUpload() {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/jpeg,image/jpg,image/png,image/webp';
        input.style.display = 'none';

        // Get progress bar elements
        const progressDiv = document.getElementById('background-upload-progress');
        const progressBar = document.getElementById('background-upload-progress-bar');
        const progressText = document.getElementById('background-upload-progress-text');

        input.addEventListener('change', async function(event) {
            const file = event.target.files[0];
            if (!file) return;

            // Validate file type
            const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
            if (!validTypes.includes(file.type.toLowerCase())) {
                showToast('Ungültiges Dateiformat. Bitte wähle ein JPG, PNG oder WebP Bild.');
                return;
            }

            // Show progress bar
            if (progressDiv) {
                progressDiv.style.display = 'block';
                if (progressBar) progressBar.style.width = '0%';
                if (progressText) progressText.textContent = 'Datei wird gelesen...';
            }

            try {
                // Read file
                const reader = new FileReader();
                reader.onload = async function(e) {
                    try {
                        if (progressBar) progressBar.style.width = '20%';
                        if (progressText) progressText.textContent = 'Upload wird vorbereitet...';

                        // Convert to blob for upload
                        const response = await fetch(e.target.result);
                        const blob = await response.blob();

                        if (progressBar) progressBar.style.width = '30%';
                        if (progressText) progressText.textContent = 'Wird hochgeladen...';

                        // Upload to S3 with progress callback
                        const s3Url = await uploadImageToS3(blob, function(progress) {
                            if (progressBar) progressBar.style.width = (30 + progress * 60) + '%';
                        });

                        if (progressBar) progressBar.style.width = '95%';
                        if (progressText) progressText.textContent = 'Hintergrund wird angewendet...';

                        // Apply background
                        applyBackgroundImage(s3Url);

                        if (progressBar) progressBar.style.width = '100%';
                        if (progressText) progressText.textContent = 'Fertig!';

                        // Hide progress bar after short delay
                        setTimeout(function() {
                            if (progressDiv) progressDiv.style.display = 'none';
                            if (progressBar) progressBar.style.width = '0%';
                        }, 800);

                    } catch (error) {
                        console.error('Error uploading background:', error);
                        showToast('Fehler beim Hochladen. Bitte versuche es erneut.');
                        if (progressDiv) progressDiv.style.display = 'none';
                    }
                };
                reader.readAsDataURL(file);
            } catch (error) {
                console.error('Error reading file:', error);
                showToast('Fehler beim Lesen der Datei. Bitte versuche es erneut.');
                if (progressDiv) progressDiv.style.display = 'none';
            }
        });

        document.body.appendChild(input);
        input.click();
        document.body.removeChild(input);
    }

})();
